/* list-item.svelte generated by Svelte v3.29.4 */
import {
	SvelteComponent,
	action_destroyer,
	append,
	assign,
	attr,
	binding_callbacks,
	check_outros,
	compute_rest_props,
	create_component,
	create_slot,
	destroy_component,
	detach,
	element,
	empty,
	exclude_internal_props,
	get_spread_update,
	group_outros,
	init,
	insert,
	is_function,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	set_attributes,
	set_data,
	space,
	text as text_1,
	transition_in,
	transition_out,
	update_slot
} from "svelte/internal";

import { createEventDispatcher, onMount, onDestroy, afterUpdate } from "svelte";

import {
	colorClasses,
	routerClasses,
	routerAttrs,
	actionsClasses,
	actionsAttrs
} from "../shared/mixins";

import {
	classNames,
	plainText,
	isStringProp,
	createEmitter
} from "../shared/utils";

import { restProps } from "../shared/rest-props";
import { f7, f7ready } from "../shared/f7";
import { hasSlots } from "../shared/has-slots";
import { useTooltip } from "../shared/use-tooltip";
import { useSmartSelect } from "../shared/use-smart-select";
import { useRouteProps } from "../shared/use-route-props";
import { getReactiveContext } from "../shared/get-reactive-context";
import Badge from "./badge";
const get_root_end_slot_changes = dirty => ({});
const get_root_end_slot_context = ctx => ({});
const get_root_slot_changes = dirty => ({});
const get_root_slot_context = ctx => ({});
const get_content_end_slot_changes_5 = dirty => ({});
const get_content_end_slot_context_5 = ctx => ({});
const get_content_slot_changes_5 = dirty => ({});
const get_content_slot_context_5 = ctx => ({});
const get_inner_end_slot_changes_5 = dirty => ({});
const get_inner_end_slot_context_5 = ctx => ({});
const get_inner_slot_changes_11 = dirty => ({});
const get_inner_slot_context_11 = ctx => ({});
const get_after_end_slot_changes_11 = dirty => ({});
const get_after_end_slot_context_11 = ctx => ({});
const get_after_slot_changes_11 = dirty => ({});
const get_after_slot_context_11 = ctx => ({});
const get_after_start_slot_changes_11 = dirty => ({});
const get_after_start_slot_context_11 = ctx => ({});
const get_after_title_slot_changes_11 = dirty => ({});
const get_after_title_slot_context_11 = ctx => ({});
const get_footer_slot_changes_11 = dirty => ({});
const get_footer_slot_context_11 = ctx => ({});
const get_title_slot_changes_11 = dirty => ({});
const get_title_slot_context_11 = ctx => ({});
const get_header_slot_changes_11 = dirty => ({});
const get_header_slot_context_11 = ctx => ({});
const get_before_title_slot_changes_11 = dirty => ({});
const get_before_title_slot_context_11 = ctx => ({});
const get_footer_slot_changes_10 = dirty => ({});
const get_footer_slot_context_10 = ctx => ({});
const get_inner_slot_changes_10 = dirty => ({});
const get_inner_slot_context_10 = ctx => ({});
const get_text_slot_changes_5 = dirty => ({});
const get_text_slot_context_5 = ctx => ({});
const get_subtitle_slot_changes_5 = dirty => ({});
const get_subtitle_slot_context_5 = ctx => ({});
const get_after_end_slot_changes_10 = dirty => ({});
const get_after_end_slot_context_10 = ctx => ({});
const get_after_slot_changes_10 = dirty => ({});
const get_after_slot_context_10 = ctx => ({});
const get_after_start_slot_changes_10 = dirty => ({});
const get_after_start_slot_context_10 = ctx => ({});
const get_after_title_slot_changes_10 = dirty => ({});
const get_after_title_slot_context_10 = ctx => ({});
const get_title_slot_changes_10 = dirty => ({});
const get_title_slot_context_10 = ctx => ({});
const get_before_title_slot_changes_10 = dirty => ({});
const get_before_title_slot_context_10 = ctx => ({});
const get_header_slot_changes_10 = dirty => ({});
const get_header_slot_context_10 = ctx => ({});
const get_inner_start_slot_changes_5 = dirty => ({});
const get_inner_start_slot_context_5 = ctx => ({});
const get_media_slot_changes_5 = dirty => ({});
const get_media_slot_context_5 = ctx => ({});
const get_content_start_slot_changes_5 = dirty => ({});
const get_content_start_slot_context_5 = ctx => ({});
const get_content_end_slot_changes_4 = dirty => ({});
const get_content_end_slot_context_4 = ctx => ({});
const get_content_slot_changes_4 = dirty => ({});
const get_content_slot_context_4 = ctx => ({});
const get_inner_end_slot_changes_4 = dirty => ({});
const get_inner_end_slot_context_4 = ctx => ({});
const get_inner_slot_changes_9 = dirty => ({});
const get_inner_slot_context_9 = ctx => ({});
const get_after_end_slot_changes_9 = dirty => ({});
const get_after_end_slot_context_9 = ctx => ({});
const get_after_slot_changes_9 = dirty => ({});
const get_after_slot_context_9 = ctx => ({});
const get_after_start_slot_changes_9 = dirty => ({});
const get_after_start_slot_context_9 = ctx => ({});
const get_after_title_slot_changes_9 = dirty => ({});
const get_after_title_slot_context_9 = ctx => ({});
const get_footer_slot_changes_9 = dirty => ({});
const get_footer_slot_context_9 = ctx => ({});
const get_title_slot_changes_9 = dirty => ({});
const get_title_slot_context_9 = ctx => ({});
const get_header_slot_changes_9 = dirty => ({});
const get_header_slot_context_9 = ctx => ({});
const get_before_title_slot_changes_9 = dirty => ({});
const get_before_title_slot_context_9 = ctx => ({});
const get_footer_slot_changes_8 = dirty => ({});
const get_footer_slot_context_8 = ctx => ({});
const get_inner_slot_changes_8 = dirty => ({});
const get_inner_slot_context_8 = ctx => ({});
const get_text_slot_changes_4 = dirty => ({});
const get_text_slot_context_4 = ctx => ({});
const get_subtitle_slot_changes_4 = dirty => ({});
const get_subtitle_slot_context_4 = ctx => ({});
const get_after_end_slot_changes_8 = dirty => ({});
const get_after_end_slot_context_8 = ctx => ({});
const get_after_slot_changes_8 = dirty => ({});
const get_after_slot_context_8 = ctx => ({});
const get_after_start_slot_changes_8 = dirty => ({});
const get_after_start_slot_context_8 = ctx => ({});
const get_after_title_slot_changes_8 = dirty => ({});
const get_after_title_slot_context_8 = ctx => ({});
const get_title_slot_changes_8 = dirty => ({});
const get_title_slot_context_8 = ctx => ({});
const get_before_title_slot_changes_8 = dirty => ({});
const get_before_title_slot_context_8 = ctx => ({});
const get_header_slot_changes_8 = dirty => ({});
const get_header_slot_context_8 = ctx => ({});
const get_inner_start_slot_changes_4 = dirty => ({});
const get_inner_start_slot_context_4 = ctx => ({});
const get_media_slot_changes_4 = dirty => ({});
const get_media_slot_context_4 = ctx => ({});
const get_content_start_slot_changes_4 = dirty => ({});
const get_content_start_slot_context_4 = ctx => ({});
const get_content_end_slot_changes_3 = dirty => ({});
const get_content_end_slot_context_3 = ctx => ({});
const get_content_slot_changes_3 = dirty => ({});
const get_content_slot_context_3 = ctx => ({});
const get_inner_end_slot_changes_3 = dirty => ({});
const get_inner_end_slot_context_3 = ctx => ({});
const get_inner_slot_changes_7 = dirty => ({});
const get_inner_slot_context_7 = ctx => ({});
const get_after_end_slot_changes_7 = dirty => ({});
const get_after_end_slot_context_7 = ctx => ({});
const get_after_slot_changes_7 = dirty => ({});
const get_after_slot_context_7 = ctx => ({});
const get_after_start_slot_changes_7 = dirty => ({});
const get_after_start_slot_context_7 = ctx => ({});
const get_after_title_slot_changes_7 = dirty => ({});
const get_after_title_slot_context_7 = ctx => ({});
const get_footer_slot_changes_7 = dirty => ({});
const get_footer_slot_context_7 = ctx => ({});
const get_title_slot_changes_7 = dirty => ({});
const get_title_slot_context_7 = ctx => ({});
const get_header_slot_changes_7 = dirty => ({});
const get_header_slot_context_7 = ctx => ({});
const get_before_title_slot_changes_7 = dirty => ({});
const get_before_title_slot_context_7 = ctx => ({});
const get_footer_slot_changes_6 = dirty => ({});
const get_footer_slot_context_6 = ctx => ({});
const get_inner_slot_changes_6 = dirty => ({});
const get_inner_slot_context_6 = ctx => ({});
const get_text_slot_changes_3 = dirty => ({});
const get_text_slot_context_3 = ctx => ({});
const get_subtitle_slot_changes_3 = dirty => ({});
const get_subtitle_slot_context_3 = ctx => ({});
const get_after_end_slot_changes_6 = dirty => ({});
const get_after_end_slot_context_6 = ctx => ({});
const get_after_slot_changes_6 = dirty => ({});
const get_after_slot_context_6 = ctx => ({});
const get_after_start_slot_changes_6 = dirty => ({});
const get_after_start_slot_context_6 = ctx => ({});
const get_after_title_slot_changes_6 = dirty => ({});
const get_after_title_slot_context_6 = ctx => ({});
const get_title_slot_changes_6 = dirty => ({});
const get_title_slot_context_6 = ctx => ({});
const get_before_title_slot_changes_6 = dirty => ({});
const get_before_title_slot_context_6 = ctx => ({});
const get_header_slot_changes_6 = dirty => ({});
const get_header_slot_context_6 = ctx => ({});
const get_inner_start_slot_changes_3 = dirty => ({});
const get_inner_start_slot_context_3 = ctx => ({});
const get_media_slot_changes_3 = dirty => ({});
const get_media_slot_context_3 = ctx => ({});
const get_content_start_slot_changes_3 = dirty => ({});
const get_content_start_slot_context_3 = ctx => ({});
const get_content_end_slot_changes_2 = dirty => ({});
const get_content_end_slot_context_2 = ctx => ({});
const get_content_slot_changes_2 = dirty => ({});
const get_content_slot_context_2 = ctx => ({});
const get_inner_end_slot_changes_2 = dirty => ({});
const get_inner_end_slot_context_2 = ctx => ({});
const get_inner_slot_changes_5 = dirty => ({});
const get_inner_slot_context_5 = ctx => ({});
const get_after_end_slot_changes_5 = dirty => ({});
const get_after_end_slot_context_5 = ctx => ({});
const get_after_slot_changes_5 = dirty => ({});
const get_after_slot_context_5 = ctx => ({});
const get_after_start_slot_changes_5 = dirty => ({});
const get_after_start_slot_context_5 = ctx => ({});
const get_after_title_slot_changes_5 = dirty => ({});
const get_after_title_slot_context_5 = ctx => ({});
const get_footer_slot_changes_5 = dirty => ({});
const get_footer_slot_context_5 = ctx => ({});
const get_title_slot_changes_5 = dirty => ({});
const get_title_slot_context_5 = ctx => ({});
const get_header_slot_changes_5 = dirty => ({});
const get_header_slot_context_5 = ctx => ({});
const get_before_title_slot_changes_5 = dirty => ({});
const get_before_title_slot_context_5 = ctx => ({});
const get_footer_slot_changes_4 = dirty => ({});
const get_footer_slot_context_4 = ctx => ({});
const get_inner_slot_changes_4 = dirty => ({});
const get_inner_slot_context_4 = ctx => ({});
const get_text_slot_changes_2 = dirty => ({});
const get_text_slot_context_2 = ctx => ({});
const get_subtitle_slot_changes_2 = dirty => ({});
const get_subtitle_slot_context_2 = ctx => ({});
const get_after_end_slot_changes_4 = dirty => ({});
const get_after_end_slot_context_4 = ctx => ({});
const get_after_slot_changes_4 = dirty => ({});
const get_after_slot_context_4 = ctx => ({});
const get_after_start_slot_changes_4 = dirty => ({});
const get_after_start_slot_context_4 = ctx => ({});
const get_after_title_slot_changes_4 = dirty => ({});
const get_after_title_slot_context_4 = ctx => ({});
const get_title_slot_changes_4 = dirty => ({});
const get_title_slot_context_4 = ctx => ({});
const get_before_title_slot_changes_4 = dirty => ({});
const get_before_title_slot_context_4 = ctx => ({});
const get_header_slot_changes_4 = dirty => ({});
const get_header_slot_context_4 = ctx => ({});
const get_inner_start_slot_changes_2 = dirty => ({});
const get_inner_start_slot_context_2 = ctx => ({});
const get_media_slot_changes_2 = dirty => ({});
const get_media_slot_context_2 = ctx => ({});
const get_content_start_slot_changes_2 = dirty => ({});
const get_content_start_slot_context_2 = ctx => ({});
const get_content_end_slot_changes_1 = dirty => ({});
const get_content_end_slot_context_1 = ctx => ({});
const get_content_slot_changes_1 = dirty => ({});
const get_content_slot_context_1 = ctx => ({});
const get_inner_end_slot_changes_1 = dirty => ({});
const get_inner_end_slot_context_1 = ctx => ({});
const get_inner_slot_changes_3 = dirty => ({});
const get_inner_slot_context_3 = ctx => ({});
const get_after_end_slot_changes_3 = dirty => ({});
const get_after_end_slot_context_3 = ctx => ({});
const get_after_slot_changes_3 = dirty => ({});
const get_after_slot_context_3 = ctx => ({});
const get_after_start_slot_changes_3 = dirty => ({});
const get_after_start_slot_context_3 = ctx => ({});
const get_after_title_slot_changes_3 = dirty => ({});
const get_after_title_slot_context_3 = ctx => ({});
const get_footer_slot_changes_3 = dirty => ({});
const get_footer_slot_context_3 = ctx => ({});
const get_title_slot_changes_3 = dirty => ({});
const get_title_slot_context_3 = ctx => ({});
const get_header_slot_changes_3 = dirty => ({});
const get_header_slot_context_3 = ctx => ({});
const get_before_title_slot_changes_3 = dirty => ({});
const get_before_title_slot_context_3 = ctx => ({});
const get_footer_slot_changes_2 = dirty => ({});
const get_footer_slot_context_2 = ctx => ({});
const get_inner_slot_changes_2 = dirty => ({});
const get_inner_slot_context_2 = ctx => ({});
const get_text_slot_changes_1 = dirty => ({});
const get_text_slot_context_1 = ctx => ({});
const get_subtitle_slot_changes_1 = dirty => ({});
const get_subtitle_slot_context_1 = ctx => ({});
const get_after_end_slot_changes_2 = dirty => ({});
const get_after_end_slot_context_2 = ctx => ({});
const get_after_slot_changes_2 = dirty => ({});
const get_after_slot_context_2 = ctx => ({});
const get_after_start_slot_changes_2 = dirty => ({});
const get_after_start_slot_context_2 = ctx => ({});
const get_after_title_slot_changes_2 = dirty => ({});
const get_after_title_slot_context_2 = ctx => ({});
const get_title_slot_changes_2 = dirty => ({});
const get_title_slot_context_2 = ctx => ({});
const get_before_title_slot_changes_2 = dirty => ({});
const get_before_title_slot_context_2 = ctx => ({});
const get_header_slot_changes_2 = dirty => ({});
const get_header_slot_context_2 = ctx => ({});
const get_inner_start_slot_changes_1 = dirty => ({});
const get_inner_start_slot_context_1 = ctx => ({});
const get_media_slot_changes_1 = dirty => ({});
const get_media_slot_context_1 = ctx => ({});
const get_content_start_slot_changes_1 = dirty => ({});
const get_content_start_slot_context_1 = ctx => ({});
const get_content_end_slot_changes = dirty => ({});
const get_content_end_slot_context = ctx => ({});
const get_content_slot_changes = dirty => ({});
const get_content_slot_context = ctx => ({});
const get_inner_end_slot_changes = dirty => ({});
const get_inner_end_slot_context = ctx => ({});
const get_inner_slot_changes_1 = dirty => ({});
const get_inner_slot_context_1 = ctx => ({});
const get_after_end_slot_changes_1 = dirty => ({});
const get_after_end_slot_context_1 = ctx => ({});
const get_after_slot_changes_1 = dirty => ({});
const get_after_slot_context_1 = ctx => ({});
const get_after_start_slot_changes_1 = dirty => ({});
const get_after_start_slot_context_1 = ctx => ({});
const get_after_title_slot_changes_1 = dirty => ({});
const get_after_title_slot_context_1 = ctx => ({});
const get_footer_slot_changes_1 = dirty => ({});
const get_footer_slot_context_1 = ctx => ({});
const get_title_slot_changes_1 = dirty => ({});
const get_title_slot_context_1 = ctx => ({});
const get_header_slot_changes_1 = dirty => ({});
const get_header_slot_context_1 = ctx => ({});
const get_before_title_slot_changes_1 = dirty => ({});
const get_before_title_slot_context_1 = ctx => ({});
const get_footer_slot_changes = dirty => ({});
const get_footer_slot_context = ctx => ({});
const get_inner_slot_changes = dirty => ({});
const get_inner_slot_context = ctx => ({});
const get_text_slot_changes = dirty => ({});
const get_text_slot_context = ctx => ({});
const get_subtitle_slot_changes = dirty => ({});
const get_subtitle_slot_context = ctx => ({});
const get_after_end_slot_changes = dirty => ({});
const get_after_end_slot_context = ctx => ({});
const get_after_slot_changes = dirty => ({});
const get_after_slot_context = ctx => ({});
const get_after_start_slot_changes = dirty => ({});
const get_after_start_slot_context = ctx => ({});
const get_after_title_slot_changes = dirty => ({});
const get_after_title_slot_context = ctx => ({});
const get_title_slot_changes = dirty => ({});
const get_title_slot_context = ctx => ({});
const get_before_title_slot_changes = dirty => ({});
const get_before_title_slot_context = ctx => ({});
const get_header_slot_changes = dirty => ({});
const get_header_slot_context = ctx => ({});
const get_inner_start_slot_changes = dirty => ({});
const get_inner_start_slot_context = ctx => ({});
const get_media_slot_changes = dirty => ({});
const get_media_slot_context = ctx => ({});
const get_content_start_slot_changes = dirty => ({});
const get_content_start_slot_context = ctx => ({});
const get_root_start_slot_changes = dirty => ({});
const get_root_start_slot_context = ctx => ({});

// (329:0) {:else}
function create_else_block(ctx) {
	let li;
	let t0;
	let current_block_type_index;
	let if_block0;
	let t1;
	let t2;
	let t3;
	let t4;
	let useTooltip_action;
	let current;
	let mounted;
	let dispose;
	const root_start_slot_template = /*#slots*/ ctx[68]["root-start"];
	const root_start_slot = create_slot(root_start_slot_template, ctx, /*$$scope*/ ctx[82], get_root_start_slot_context);
	const if_block_creators = [create_if_block_4, create_if_block_67, create_else_block_7];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*swipeout*/ ctx[14]) return 0;
		if (/*isLink*/ ctx[38]) return 1;
		return 2;
	}

	current_block_type_index = select_block_type_1(ctx, [-1]);
	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	let if_block1 = /*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && !/*isSortableOpposite*/ ctx[32] && create_if_block_3(ctx);
	let if_block2 = (/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_2(ctx);
	const root_slot_template = /*#slots*/ ctx[68].root;
	const root_slot = create_slot(root_slot_template, ctx, /*$$scope*/ ctx[82], get_root_slot_context);
	const root_end_slot_template = /*#slots*/ ctx[68]["root-end"];
	const root_end_slot = create_slot(root_end_slot_template, ctx, /*$$scope*/ ctx[82], get_root_end_slot_context);

	let li_levels = [
		{ class: /*liClasses*/ ctx[34] },
		{
			"data-virtual-list-index": /*virtualListIndex*/ ctx[24]
		},
		restProps(/*$$restProps*/ ctx[48])
	];

	let li_data = {};

	for (let i = 0; i < li_levels.length; i += 1) {
		li_data = assign(li_data, li_levels[i]);
	}

	return {
		c() {
			li = element("li");
			if (root_start_slot) root_start_slot.c();
			t0 = space();
			if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (if_block2) if_block2.c();
			t3 = space();
			if (root_slot) root_slot.c();
			t4 = space();
			if (root_end_slot) root_end_slot.c();
			set_attributes(li, li_data);
		},
		m(target, anchor) {
			insert(target, li, anchor);

			if (root_start_slot) {
				root_start_slot.m(li, null);
			}

			append(li, t0);
			if_blocks[current_block_type_index].m(li, null);
			append(li, t1);
			if (if_block1) if_block1.m(li, null);
			append(li, t2);
			if (if_block2) if_block2.m(li, null);
			append(li, t3);

			if (root_slot) {
				root_slot.m(li, null);
			}

			append(li, t4);

			if (root_end_slot) {
				root_end_slot.m(li, null);
			}

			/*li_binding_2*/ ctx[81](li);
			current = true;

			if (!mounted) {
				dispose = action_destroyer(useTooltip_action = useTooltip.call(null, li, {
					tooltip: /*tooltip*/ ctx[7],
					tooltipTrigger: /*tooltipTrigger*/ ctx[8]
				}));

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (root_start_slot) {
				if (root_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(root_start_slot, root_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_root_start_slot_changes, get_root_start_slot_context);
				}
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block0 = if_blocks[current_block_type_index];

				if (!if_block0) {
					if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block0.c();
				}

				transition_in(if_block0, 1);
				if_block0.m(li, t1);
			}

			if (/*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && !/*isSortableOpposite*/ ctx[32]) {
				if (if_block1) {
					
				} else {
					if_block1 = create_if_block_3(ctx);
					if_block1.c();
					if_block1.m(li, t2);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_2(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(li, t3);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (root_slot) {
				if (root_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(root_slot, root_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_root_slot_changes, get_root_slot_context);
				}
			}

			if (root_end_slot) {
				if (root_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(root_end_slot, root_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_root_end_slot_changes, get_root_end_slot_context);
				}
			}

			set_attributes(li, li_data = get_spread_update(li_levels, [
				(!current || dirty[1] & /*liClasses*/ 8) && { class: /*liClasses*/ ctx[34] },
				(!current || dirty[0] & /*virtualListIndex*/ 16777216) && {
					"data-virtual-list-index": /*virtualListIndex*/ ctx[24]
				},
				dirty[1] & /*$$restProps*/ 131072 && restProps(/*$$restProps*/ ctx[48])
			]));

			if (useTooltip_action && is_function(useTooltip_action.update) && dirty[0] & /*tooltip, tooltipTrigger*/ 384) useTooltip_action.update.call(null, {
				tooltip: /*tooltip*/ ctx[7],
				tooltipTrigger: /*tooltipTrigger*/ ctx[8]
			});
		},
		i(local) {
			if (current) return;
			transition_in(root_start_slot, local);
			transition_in(if_block0);
			transition_in(if_block2);
			transition_in(root_slot, local);
			transition_in(root_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(root_start_slot, local);
			transition_out(if_block0);
			transition_out(if_block2);
			transition_out(root_slot, local);
			transition_out(root_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(li);
			if (root_start_slot) root_start_slot.d(detaching);
			if_blocks[current_block_type_index].d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (root_slot) root_slot.d(detaching);
			if (root_end_slot) root_end_slot.d(detaching);
			/*li_binding_2*/ ctx[81](null);
			mounted = false;
			dispose();
		}
	};
}

// (324:19) 
function create_if_block_1(ctx) {
	let li;
	let t0_value = plainText(/*title*/ ctx[1]) + "";
	let t0;
	let t1;
	let useTooltip_action;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	let li_levels = [
		{ class: /*liClasses*/ ctx[34] },
		{
			"data-virtual-list-index": /*virtualListIndex*/ ctx[24]
		},
		restProps(/*$$restProps*/ ctx[48])
	];

	let li_data = {};

	for (let i = 0; i < li_levels.length; i += 1) {
		li_data = assign(li_data, li_levels[i]);
	}

	return {
		c() {
			li = element("li");
			t0 = text_1(t0_value);
			t1 = space();
			if (default_slot) default_slot.c();
			set_attributes(li, li_data);
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, t0);
			append(li, t1);

			if (default_slot) {
				default_slot.m(li, null);
			}

			/*li_binding_1*/ ctx[70](li);
			current = true;

			if (!mounted) {
				dispose = [
					listen(li, "click", /*onClick*/ ctx[46]),
					action_destroyer(useTooltip_action = useTooltip.call(null, li, {
						tooltip: /*tooltip*/ ctx[7],
						tooltipTrigger: /*tooltipTrigger*/ ctx[8]
					}))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*title*/ 2) && t0_value !== (t0_value = plainText(/*title*/ ctx[1]) + "")) set_data(t0, t0_value);

			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}

			set_attributes(li, li_data = get_spread_update(li_levels, [
				(!current || dirty[1] & /*liClasses*/ 8) && { class: /*liClasses*/ ctx[34] },
				(!current || dirty[0] & /*virtualListIndex*/ 16777216) && {
					"data-virtual-list-index": /*virtualListIndex*/ ctx[24]
				},
				dirty[1] & /*$$restProps*/ 131072 && restProps(/*$$restProps*/ ctx[48])
			]));

			if (useTooltip_action && is_function(useTooltip_action.update) && dirty[0] & /*tooltip, tooltipTrigger*/ 384) useTooltip_action.update.call(null, {
				tooltip: /*tooltip*/ ctx[7],
				tooltipTrigger: /*tooltipTrigger*/ ctx[8]
			});
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(li);
			if (default_slot) default_slot.d(detaching);
			/*li_binding_1*/ ctx[70](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (320:0) {#if (divider || groupTitle)}
function create_if_block(ctx) {
	let li;
	let span;
	let useTooltip_action;
	let current;
	let mounted;
	let dispose;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);
	const default_slot_or_fallback = default_slot || fallback_block(ctx);

	let li_levels = [
		{ class: /*liClasses*/ ctx[34] },
		{
			"data-virtual-list-index": /*virtualListIndex*/ ctx[24]
		},
		restProps(/*$$restProps*/ ctx[48])
	];

	let li_data = {};

	for (let i = 0; i < li_levels.length; i += 1) {
		li_data = assign(li_data, li_levels[i]);
	}

	return {
		c() {
			li = element("li");
			span = element("span");
			if (default_slot_or_fallback) default_slot_or_fallback.c();
			set_attributes(li, li_data);
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, span);

			if (default_slot_or_fallback) {
				default_slot_or_fallback.m(span, null);
			}

			/*li_binding*/ ctx[69](li);
			current = true;

			if (!mounted) {
				dispose = [
					listen(li, "click", /*onClick*/ ctx[46]),
					action_destroyer(useTooltip_action = useTooltip.call(null, li, {
						tooltip: /*tooltip*/ ctx[7],
						tooltipTrigger: /*tooltipTrigger*/ ctx[8]
					}))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			} else {
				if (default_slot_or_fallback && default_slot_or_fallback.p && dirty[0] & /*title*/ 2) {
					default_slot_or_fallback.p(ctx, dirty);
				}
			}

			set_attributes(li, li_data = get_spread_update(li_levels, [
				(!current || dirty[1] & /*liClasses*/ 8) && { class: /*liClasses*/ ctx[34] },
				(!current || dirty[0] & /*virtualListIndex*/ 16777216) && {
					"data-virtual-list-index": /*virtualListIndex*/ ctx[24]
				},
				dirty[1] & /*$$restProps*/ 131072 && restProps(/*$$restProps*/ ctx[48])
			]));

			if (useTooltip_action && is_function(useTooltip_action.update) && dirty[0] & /*tooltip, tooltipTrigger*/ 384) useTooltip_action.update.call(null, {
				tooltip: /*tooltip*/ ctx[7],
				tooltipTrigger: /*tooltipTrigger*/ ctx[8]
			});
		},
		i(local) {
			if (current) return;
			transition_in(default_slot_or_fallback, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot_or_fallback, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(li);
			if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
			/*li_binding*/ ctx[69](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (809:6) {:else}
function create_else_block_7(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_88, create_else_block_9];
	const if_blocks = [];

	function select_block_type_8(ctx, dirty) {
		if (/*checkbox*/ ctx[17] || /*radio*/ ctx[18]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_8(ctx, [-1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_8(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (693:6) {#if isLink}
function create_if_block_67(ctx) {
	let a;
	let div1;
	let t0;
	let t1;
	let t2;
	let div0;
	let t3;
	let current_block_type_index;
	let if_block2;
	let t4;
	let t5;
	let t6;
	let useRouteProps_action;
	let current;
	let mounted;
	let dispose;
	const content_start_slot_template = /*#slots*/ ctx[68]["content-start"];
	const content_start_slot = create_slot(content_start_slot_template, ctx, /*$$scope*/ ctx[82], get_content_start_slot_context_3);
	let if_block0 = /*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32] && create_if_block_87(ctx);
	let if_block1 = /*hasMedia*/ ctx[39] && create_if_block_85(ctx);
	const inner_start_slot_template = /*#slots*/ ctx[68]["inner-start"];
	const inner_start_slot = create_slot(inner_start_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_start_slot_context_3);
	const if_block_creators = [create_if_block_68, create_else_block_6];
	const if_blocks = [];

	function select_block_type_7(ctx, dirty) {
		if (/*isMedia*/ ctx[30]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_7(ctx, [-1]);
	if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	const inner_end_slot_template = /*#slots*/ ctx[68]["inner-end"];
	const inner_end_slot = create_slot(inner_end_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_end_slot_context_3);
	const content_slot_template = /*#slots*/ ctx[68].content;
	const content_slot = create_slot(content_slot_template, ctx, /*$$scope*/ ctx[82], get_content_slot_context_3);
	const content_end_slot_template = /*#slots*/ ctx[68]["content-end"];
	const content_end_slot = create_slot(content_end_slot_template, ctx, /*$$scope*/ ctx[82], get_content_end_slot_context_3);
	let a_levels = [{ class: /*linkClasses*/ ctx[36] }, /*linkAttrs*/ ctx[37]];
	let a_data = {};

	for (let i = 0; i < a_levels.length; i += 1) {
		a_data = assign(a_data, a_levels[i]);
	}

	return {
		c() {
			a = element("a");
			div1 = element("div");
			if (content_start_slot) content_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			div0 = element("div");
			if (inner_start_slot) inner_start_slot.c();
			t3 = space();
			if_block2.c();
			t4 = space();
			if (inner_end_slot) inner_end_slot.c();
			t5 = space();
			if (content_slot) content_slot.c();
			t6 = space();
			if (content_end_slot) content_end_slot.c();
			attr(div0, "class", "item-inner");
			attr(div1, "class", /*contentClasses*/ ctx[35]);
			set_attributes(a, a_data);
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, div1);

			if (content_start_slot) {
				content_start_slot.m(div1, null);
			}

			append(div1, t0);
			if (if_block0) if_block0.m(div1, null);
			append(div1, t1);
			if (if_block1) if_block1.m(div1, null);
			append(div1, t2);
			append(div1, div0);

			if (inner_start_slot) {
				inner_start_slot.m(div0, null);
			}

			append(div0, t3);
			if_blocks[current_block_type_index].m(div0, null);
			append(div0, t4);

			if (inner_end_slot) {
				inner_end_slot.m(div0, null);
			}

			/*div0_binding_2*/ ctx[76](div0);
			append(div1, t5);

			if (content_slot) {
				content_slot.m(div1, null);
			}

			append(div1, t6);

			if (content_end_slot) {
				content_end_slot.m(div1, null);
			}

			/*a_binding_1*/ ctx[77](a);
			current = true;

			if (!mounted) {
				dispose = [
					action_destroyer(useRouteProps_action = useRouteProps.call(null, a, /*routeProps*/ ctx[25])),
					listen(a, "click", /*onClick*/ ctx[46])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (content_start_slot) {
				if (content_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_start_slot, content_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_start_slot_changes_3, get_content_start_slot_context_3);
				}
			}

			if (/*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32]) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_87(ctx);
					if_block0.c();
					if_block0.m(div1, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*hasMedia*/ ctx[39]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasMedia*/ 256) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_85(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_start_slot) {
				if (inner_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_start_slot, inner_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_start_slot_changes_3, get_inner_start_slot_context_3);
				}
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_7(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block2 = if_blocks[current_block_type_index];

				if (!if_block2) {
					if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block2.c();
				}

				transition_in(if_block2, 1);
				if_block2.m(div0, t4);
			}

			if (inner_end_slot) {
				if (inner_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_end_slot, inner_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_end_slot_changes_3, get_inner_end_slot_context_3);
				}
			}

			if (content_slot) {
				if (content_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_slot, content_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_slot_changes_3, get_content_slot_context_3);
				}
			}

			if (content_end_slot) {
				if (content_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_end_slot, content_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_end_slot_changes_3, get_content_end_slot_context_3);
				}
			}

			if (!current || dirty[1] & /*contentClasses*/ 16) {
				attr(div1, "class", /*contentClasses*/ ctx[35]);
			}

			set_attributes(a, a_data = get_spread_update(a_levels, [
				(!current || dirty[1] & /*linkClasses*/ 32) && { class: /*linkClasses*/ ctx[36] },
				dirty[1] & /*linkAttrs*/ 64 && /*linkAttrs*/ ctx[37]
			]));

			if (useRouteProps_action && is_function(useRouteProps_action.update) && dirty[0] & /*routeProps*/ 33554432) useRouteProps_action.update.call(null, /*routeProps*/ ctx[25]);
		},
		i(local) {
			if (current) return;
			transition_in(content_start_slot, local);
			transition_in(if_block1);
			transition_in(inner_start_slot, local);
			transition_in(if_block2);
			transition_in(inner_end_slot, local);
			transition_in(content_slot, local);
			transition_in(content_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(content_start_slot, local);
			transition_out(if_block1);
			transition_out(inner_start_slot, local);
			transition_out(if_block2);
			transition_out(inner_end_slot, local);
			transition_out(content_slot, local);
			transition_out(content_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(a);
			if (content_start_slot) content_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (inner_start_slot) inner_start_slot.d(detaching);
			if_blocks[current_block_type_index].d();
			if (inner_end_slot) inner_end_slot.d(detaching);
			/*div0_binding_2*/ ctx[76](null);
			if (content_slot) content_slot.d(detaching);
			if (content_end_slot) content_end_slot.d(detaching);
			/*a_binding_1*/ ctx[77](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (332:4) {#if swipeout}
function create_if_block_4(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let current;
	const if_block_creators = [create_if_block_5, create_else_block_2];
	const if_blocks = [];

	function select_block_type_2(ctx, dirty) {
		if (/*isLink*/ ctx[38]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_2(ctx, [-1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "class", "swipeout-content");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_blocks[current_block_type_index].m(div, null);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_2(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(div, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if_blocks[current_block_type_index].d();
		}
	};
}

// (935:8) {:else}
function create_else_block_9(ctx) {
	let div1;
	let t0;
	let t1;
	let t2;
	let div0;
	let t3;
	let current_block_type_index;
	let if_block2;
	let t4;
	let t5;
	let t6;
	let current;
	let mounted;
	let dispose;
	const content_start_slot_template = /*#slots*/ ctx[68]["content-start"];
	const content_start_slot = create_slot(content_start_slot_template, ctx, /*$$scope*/ ctx[82], get_content_start_slot_context_5);
	let if_block0 = /*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32] && create_if_block_128(ctx);
	let if_block1 = /*hasMedia*/ ctx[39] && create_if_block_126(ctx);
	const inner_start_slot_template = /*#slots*/ ctx[68]["inner-start"];
	const inner_start_slot = create_slot(inner_start_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_start_slot_context_5);
	const if_block_creators = [create_if_block_109, create_else_block_10];
	const if_blocks = [];

	function select_block_type_10(ctx, dirty) {
		if (/*isMedia*/ ctx[30]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_10(ctx, [-1]);
	if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	const inner_end_slot_template = /*#slots*/ ctx[68]["inner-end"];
	const inner_end_slot = create_slot(inner_end_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_end_slot_context_5);
	const content_slot_template = /*#slots*/ ctx[68].content;
	const content_slot = create_slot(content_slot_template, ctx, /*$$scope*/ ctx[82], get_content_slot_context_5);
	const content_end_slot_template = /*#slots*/ ctx[68]["content-end"];
	const content_end_slot = create_slot(content_end_slot_template, ctx, /*$$scope*/ ctx[82], get_content_end_slot_context_5);

	return {
		c() {
			div1 = element("div");
			if (content_start_slot) content_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			div0 = element("div");
			if (inner_start_slot) inner_start_slot.c();
			t3 = space();
			if_block2.c();
			t4 = space();
			if (inner_end_slot) inner_end_slot.c();
			t5 = space();
			if (content_slot) content_slot.c();
			t6 = space();
			if (content_end_slot) content_end_slot.c();
			attr(div0, "class", "item-inner");
			attr(div1, "class", /*contentClasses*/ ctx[35]);
		},
		m(target, anchor) {
			insert(target, div1, anchor);

			if (content_start_slot) {
				content_start_slot.m(div1, null);
			}

			append(div1, t0);
			if (if_block0) if_block0.m(div1, null);
			append(div1, t1);
			if (if_block1) if_block1.m(div1, null);
			append(div1, t2);
			append(div1, div0);

			if (inner_start_slot) {
				inner_start_slot.m(div0, null);
			}

			append(div0, t3);
			if_blocks[current_block_type_index].m(div0, null);
			append(div0, t4);

			if (inner_end_slot) {
				inner_end_slot.m(div0, null);
			}

			/*div0_binding_3*/ ctx[80](div0);
			append(div1, t5);

			if (content_slot) {
				content_slot.m(div1, null);
			}

			append(div1, t6);

			if (content_end_slot) {
				content_end_slot.m(div1, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(div1, "click", /*onClick*/ ctx[46]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (content_start_slot) {
				if (content_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_start_slot, content_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_start_slot_changes_5, get_content_start_slot_context_5);
				}
			}

			if (/*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32]) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_128(ctx);
					if_block0.c();
					if_block0.m(div1, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*hasMedia*/ ctx[39]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasMedia*/ 256) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_126(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_start_slot) {
				if (inner_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_start_slot, inner_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_start_slot_changes_5, get_inner_start_slot_context_5);
				}
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_10(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block2 = if_blocks[current_block_type_index];

				if (!if_block2) {
					if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block2.c();
				}

				transition_in(if_block2, 1);
				if_block2.m(div0, t4);
			}

			if (inner_end_slot) {
				if (inner_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_end_slot, inner_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_end_slot_changes_5, get_inner_end_slot_context_5);
				}
			}

			if (content_slot) {
				if (content_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_slot, content_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_slot_changes_5, get_content_slot_context_5);
				}
			}

			if (content_end_slot) {
				if (content_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_end_slot, content_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_end_slot_changes_5, get_content_end_slot_context_5);
				}
			}

			if (!current || dirty[1] & /*contentClasses*/ 16) {
				attr(div1, "class", /*contentClasses*/ ctx[35]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(content_start_slot, local);
			transition_in(if_block1);
			transition_in(inner_start_slot, local);
			transition_in(if_block2);
			transition_in(inner_end_slot, local);
			transition_in(content_slot, local);
			transition_in(content_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(content_start_slot, local);
			transition_out(if_block1);
			transition_out(inner_start_slot, local);
			transition_out(if_block2);
			transition_out(inner_end_slot, local);
			transition_out(content_slot, local);
			transition_out(content_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (content_start_slot) content_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (inner_start_slot) inner_start_slot.d(detaching);
			if_blocks[current_block_type_index].d();
			if (inner_end_slot) inner_end_slot.d(detaching);
			/*div0_binding_3*/ ctx[80](null);
			if (content_slot) content_slot.d(detaching);
			if (content_end_slot) content_end_slot.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

// (811:8) {#if checkbox || radio}
function create_if_block_88(ctx) {
	let label;
	let t0;
	let t1;
	let input;
	let input_value_value;
	let input_type_value;
	let t2;
	let i;
	let i_class_value;
	let t3;
	let t4;
	let div;
	let t5;
	let current_block_type_index;
	let if_block2;
	let t6;
	let t7;
	let t8;
	let current;
	let mounted;
	let dispose;
	const content_start_slot_template = /*#slots*/ ctx[68]["content-start"];
	const content_start_slot = create_slot(content_start_slot_template, ctx, /*$$scope*/ ctx[82], get_content_start_slot_context_4);
	let if_block0 = /*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32] && create_if_block_108(ctx);
	let if_block1 = /*hasMedia*/ ctx[39] && create_if_block_106(ctx);
	const inner_start_slot_template = /*#slots*/ ctx[68]["inner-start"];
	const inner_start_slot = create_slot(inner_start_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_start_slot_context_4);
	const if_block_creators = [create_if_block_89, create_else_block_8];
	const if_blocks = [];

	function select_block_type_9(ctx, dirty) {
		if (/*isMedia*/ ctx[30]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_9(ctx, [-1]);
	if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	const inner_end_slot_template = /*#slots*/ ctx[68]["inner-end"];
	const inner_end_slot = create_slot(inner_end_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_end_slot_context_4);
	const content_slot_template = /*#slots*/ ctx[68].content;
	const content_slot = create_slot(content_slot_template, ctx, /*$$scope*/ ctx[82], get_content_slot_context_4);
	const content_end_slot_template = /*#slots*/ ctx[68]["content-end"];
	const content_end_slot = create_slot(content_end_slot_template, ctx, /*$$scope*/ ctx[82], get_content_end_slot_context_4);

	return {
		c() {
			label = element("label");
			if (content_start_slot) content_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			input = element("input");
			t2 = space();
			i = element("i");
			t3 = space();
			if (if_block1) if_block1.c();
			t4 = space();
			div = element("div");
			if (inner_start_slot) inner_start_slot.c();
			t5 = space();
			if_block2.c();
			t6 = space();
			if (inner_end_slot) inner_end_slot.c();
			t7 = space();
			if (content_slot) content_slot.c();
			t8 = space();
			if (content_end_slot) content_end_slot.c();

			input.value = input_value_value = typeof /*value*/ ctx[20] === "undefined"
			? ""
			: /*value*/ ctx[20];

			attr(input, "name", /*name*/ ctx[19]);
			input.checked = /*checked*/ ctx[0];
			input.readOnly = /*readonly*/ ctx[21];
			input.disabled = /*disabled*/ ctx[23];
			input.required = /*required*/ ctx[22];
			attr(input, "type", input_type_value = /*radio*/ ctx[18] ? "radio" : "checkbox");
			attr(i, "class", i_class_value = `icon icon-${/*radio*/ ctx[18] ? "radio" : "checkbox"}`);
			attr(div, "class", "item-inner");
			attr(label, "class", /*contentClasses*/ ctx[35]);
		},
		m(target, anchor) {
			insert(target, label, anchor);

			if (content_start_slot) {
				content_start_slot.m(label, null);
			}

			append(label, t0);
			if (if_block0) if_block0.m(label, null);
			append(label, t1);
			append(label, input);
			/*input_binding_1*/ ctx[78](input);
			append(label, t2);
			append(label, i);
			append(label, t3);
			if (if_block1) if_block1.m(label, null);
			append(label, t4);
			append(label, div);

			if (inner_start_slot) {
				inner_start_slot.m(div, null);
			}

			append(div, t5);
			if_blocks[current_block_type_index].m(div, null);
			append(div, t6);

			if (inner_end_slot) {
				inner_end_slot.m(div, null);
			}

			/*div_binding_1*/ ctx[79](div);
			append(label, t7);

			if (content_slot) {
				content_slot.m(label, null);
			}

			append(label, t8);

			if (content_end_slot) {
				content_end_slot.m(label, null);
			}

			current = true;

			if (!mounted) {
				dispose = [
					listen(input, "change", /*onChange*/ ctx[47]),
					listen(label, "click", /*onClick*/ ctx[46])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (content_start_slot) {
				if (content_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_start_slot, content_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_start_slot_changes_4, get_content_start_slot_context_4);
				}
			}

			if (/*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32]) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_108(ctx);
					if_block0.c();
					if_block0.m(label, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (!current || dirty[0] & /*value*/ 1048576 && input_value_value !== (input_value_value = typeof /*value*/ ctx[20] === "undefined"
			? ""
			: /*value*/ ctx[20]) && input.value !== input_value_value) {
				input.value = input_value_value;
			}

			if (!current || dirty[0] & /*name*/ 524288) {
				attr(input, "name", /*name*/ ctx[19]);
			}

			if (!current || dirty[0] & /*checked*/ 1) {
				input.checked = /*checked*/ ctx[0];
			}

			if (!current || dirty[0] & /*readonly*/ 2097152) {
				input.readOnly = /*readonly*/ ctx[21];
			}

			if (!current || dirty[0] & /*disabled*/ 8388608) {
				input.disabled = /*disabled*/ ctx[23];
			}

			if (!current || dirty[0] & /*required*/ 4194304) {
				input.required = /*required*/ ctx[22];
			}

			if (!current || dirty[0] & /*radio*/ 262144 && input_type_value !== (input_type_value = /*radio*/ ctx[18] ? "radio" : "checkbox")) {
				attr(input, "type", input_type_value);
			}

			if (!current || dirty[0] & /*radio*/ 262144 && i_class_value !== (i_class_value = `icon icon-${/*radio*/ ctx[18] ? "radio" : "checkbox"}`)) {
				attr(i, "class", i_class_value);
			}

			if (/*hasMedia*/ ctx[39]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasMedia*/ 256) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_106(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(label, t4);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_start_slot) {
				if (inner_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_start_slot, inner_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_start_slot_changes_4, get_inner_start_slot_context_4);
				}
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_9(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block2 = if_blocks[current_block_type_index];

				if (!if_block2) {
					if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block2.c();
				}

				transition_in(if_block2, 1);
				if_block2.m(div, t6);
			}

			if (inner_end_slot) {
				if (inner_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_end_slot, inner_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_end_slot_changes_4, get_inner_end_slot_context_4);
				}
			}

			if (content_slot) {
				if (content_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_slot, content_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_slot_changes_4, get_content_slot_context_4);
				}
			}

			if (content_end_slot) {
				if (content_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_end_slot, content_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_end_slot_changes_4, get_content_end_slot_context_4);
				}
			}

			if (!current || dirty[1] & /*contentClasses*/ 16) {
				attr(label, "class", /*contentClasses*/ ctx[35]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(content_start_slot, local);
			transition_in(if_block1);
			transition_in(inner_start_slot, local);
			transition_in(if_block2);
			transition_in(inner_end_slot, local);
			transition_in(content_slot, local);
			transition_in(content_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(content_start_slot, local);
			transition_out(if_block1);
			transition_out(inner_start_slot, local);
			transition_out(if_block2);
			transition_out(inner_end_slot, local);
			transition_out(content_slot, local);
			transition_out(content_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(label);
			if (content_start_slot) content_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			/*input_binding_1*/ ctx[78](null);
			if (if_block1) if_block1.d();
			if (inner_start_slot) inner_start_slot.d(detaching);
			if_blocks[current_block_type_index].d();
			if (inner_end_slot) inner_end_slot.d(detaching);
			/*div_binding_1*/ ctx[79](null);
			if (content_slot) content_slot.d(detaching);
			if (content_end_slot) content_end_slot.d(detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (938:12) {#if isSortable && sortable !== false && isSortableOpposite}
function create_if_block_128(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "sortable-handler");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (941:12) {#if hasMedia}
function create_if_block_126(ctx) {
	let div;
	let t;
	let current;
	let if_block = typeof /*media*/ ctx[3] !== "undefined" && create_if_block_127(ctx);
	const media_slot_template = /*#slots*/ ctx[68].media;
	const media_slot = create_slot(media_slot_template, ctx, /*$$scope*/ ctx[82], get_media_slot_context_5);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			if (media_slot) media_slot.c();
			attr(div, "class", "item-media");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			append(div, t);

			if (media_slot) {
				media_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (typeof /*media*/ ctx[3] !== "undefined") {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_127(ctx);
					if_block.c();
					if_block.m(div, t);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (media_slot) {
				if (media_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(media_slot, media_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_media_slot_changes_5, get_media_slot_context_5);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(media_slot, local);
			current = true;
		},
		o(local) {
			transition_out(media_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			if (media_slot) media_slot.d(detaching);
		}
	};
}

// (943:16) {#if typeof media !== 'undefined'}
function create_if_block_127(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (img.src !== (img_src_value = /*media*/ ctx[3])) attr(img, "src", img_src_value);
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*media*/ 8 && img.src !== (img_src_value = /*media*/ ctx[3])) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (1003:14) {:else}
function create_else_block_10(ctx) {
	let t0;
	let t1;
	let t2;
	let t3;
	let t4;
	let if_block2_anchor;
	let current;
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_11);
	let if_block0 = (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) && create_if_block_123(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_11);
	let if_block1 = /*hasAfter*/ ctx[45] && create_if_block_120(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_11);
	let if_block2 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_119(ctx);

	return {
		c() {
			if (before_title_slot) before_title_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (after_title_slot) after_title_slot.c();
			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			if (inner_slot) inner_slot.c();
			t4 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
		},
		m(target, anchor) {
			if (before_title_slot) {
				before_title_slot.m(target, anchor);
			}

			insert(target, t0, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t1, anchor);

			if (after_title_slot) {
				after_title_slot.m(target, anchor);
			}

			insert(target, t2, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t3, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t4, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_11, get_before_title_slot_context_11);
				}
			}

			if (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasTitle, hasHeader, hasFooter*/ 3584) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_123(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t1.parentNode, t1);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_11, get_after_title_slot_context_11);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_120(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t3.parentNode, t3);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_11, get_inner_slot_context_11);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_119(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(before_title_slot, local);
			transition_in(if_block0);
			transition_in(after_title_slot, local);
			transition_in(if_block1);
			transition_in(inner_slot, local);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(before_title_slot, local);
			transition_out(if_block0);
			transition_out(after_title_slot, local);
			transition_out(if_block1);
			transition_out(inner_slot, local);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (before_title_slot) before_title_slot.d(detaching);
			if (detaching) detach(t0);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t1);
			if (after_title_slot) after_title_slot.d(detaching);
			if (detaching) detach(t2);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t3);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t4);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

// (951:14) {#if isMedia}
function create_if_block_109(ctx) {
	let t0;
	let div;
	let t1;
	let t2;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let t8;
	let if_block6_anchor;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_118(ctx);
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_10);
	let if_block1 = /*hasTitle*/ ctx[40] && create_if_block_117(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_10);
	let if_block2 = /*hasAfter*/ ctx[45] && create_if_block_114(ctx);
	let if_block3 = /*hasSubtitle*/ ctx[43] && create_if_block_113(ctx);
	let if_block4 = /*hasText*/ ctx[44] && create_if_block_112(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_10);
	let if_block5 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_111(ctx);
	let if_block6 = /*hasFooter*/ ctx[42] && create_if_block_110(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			div = element("div");
			if (before_title_slot) before_title_slot.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_title_slot) after_title_slot.c();
			t3 = space();
			if (if_block2) if_block2.c();
			t4 = space();
			if (if_block3) if_block3.c();
			t5 = space();
			if (if_block4) if_block4.c();
			t6 = space();
			if (inner_slot) inner_slot.c();
			t7 = space();
			if (if_block5) if_block5.c();
			t8 = space();
			if (if_block6) if_block6.c();
			if_block6_anchor = empty();
			attr(div, "class", "item-title-row");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			insert(target, div, anchor);

			if (before_title_slot) {
				before_title_slot.m(div, null);
			}

			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_title_slot) {
				after_title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block2) if_block2.m(div, null);
			insert(target, t4, anchor);
			if (if_block3) if_block3.m(target, anchor);
			insert(target, t5, anchor);
			if (if_block4) if_block4.m(target, anchor);
			insert(target, t6, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t7, anchor);
			if (if_block5) if_block5.m(target, anchor);
			insert(target, t8, anchor);
			if (if_block6) if_block6.m(target, anchor);
			insert(target, if_block6_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_118(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_10, get_before_title_slot_context_10);
				}
			}

			if (/*hasTitle*/ ctx[40]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasTitle*/ 512) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_117(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_10, get_after_title_slot_context_10);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_114(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*hasSubtitle*/ ctx[43]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty[1] & /*hasSubtitle*/ 4096) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block_113(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(t5.parentNode, t5);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (/*hasText*/ ctx[44]) {
				if (if_block4) {
					if_block4.p(ctx, dirty);

					if (dirty[1] & /*hasText*/ 8192) {
						transition_in(if_block4, 1);
					}
				} else {
					if_block4 = create_if_block_112(ctx);
					if_block4.c();
					transition_in(if_block4, 1);
					if_block4.m(t6.parentNode, t6);
				}
			} else if (if_block4) {
				group_outros();

				transition_out(if_block4, 1, 1, () => {
					if_block4 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_10, get_inner_slot_context_10);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block5) {
					if_block5.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block5, 1);
					}
				} else {
					if_block5 = create_if_block_111(ctx);
					if_block5.c();
					transition_in(if_block5, 1);
					if_block5.m(t8.parentNode, t8);
				}
			} else if (if_block5) {
				group_outros();

				transition_out(if_block5, 1, 1, () => {
					if_block5 = null;
				});

				check_outros();
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block6) {
					if_block6.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block6, 1);
					}
				} else {
					if_block6 = create_if_block_110(ctx);
					if_block6.c();
					transition_in(if_block6, 1);
					if_block6.m(if_block6_anchor.parentNode, if_block6_anchor);
				}
			} else if (if_block6) {
				group_outros();

				transition_out(if_block6, 1, 1, () => {
					if_block6 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(before_title_slot, local);
			transition_in(if_block1);
			transition_in(after_title_slot, local);
			transition_in(if_block2);
			transition_in(if_block3);
			transition_in(if_block4);
			transition_in(inner_slot, local);
			transition_in(if_block5);
			transition_in(if_block6);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(before_title_slot, local);
			transition_out(if_block1);
			transition_out(after_title_slot, local);
			transition_out(if_block2);
			transition_out(if_block3);
			transition_out(if_block4);
			transition_out(inner_slot, local);
			transition_out(if_block5);
			transition_out(if_block6);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (before_title_slot) before_title_slot.d(detaching);
			if (if_block1) if_block1.d();
			if (after_title_slot) after_title_slot.d(detaching);
			if (if_block2) if_block2.d();
			if (detaching) detach(t4);
			if (if_block3) if_block3.d(detaching);
			if (detaching) detach(t5);
			if (if_block4) if_block4.d(detaching);
			if (detaching) detach(t6);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t7);
			if (if_block5) if_block5.d(detaching);
			if (detaching) detach(t8);
			if (if_block6) if_block6.d(detaching);
			if (detaching) detach(if_block6_anchor);
		}
	};
}

// (1005:16) {#if (hasTitle || hasHeader || hasFooter)}
function create_if_block_123(ctx) {
	let div;
	let t0;
	let t1_value = plainText(/*title*/ ctx[1]) + "";
	let t1;
	let t2;
	let t3;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_125(ctx);
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_11);
	let if_block1 = /*hasFooter*/ ctx[42] && create_if_block_124(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			t1 = text_1(t1_value);
			t2 = space();
			if (title_slot) title_slot.c();
			t3 = space();
			if (if_block1) if_block1.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t0);
			append(div, t1);
			append(div, t2);

			if (title_slot) {
				title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block1) if_block1.m(div, null);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_125(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if ((!current || dirty[0] & /*title*/ 2) && t1_value !== (t1_value = plainText(/*title*/ ctx[1]) + "")) set_data(t1, t1_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_11, get_title_slot_context_11);
				}
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_124(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(title_slot, local);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(title_slot, local);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (title_slot) title_slot.d(detaching);
			if (if_block1) if_block1.d();
		}
	};
}

// (1007:20) {#if hasHeader}
function create_if_block_125(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_11);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_11, get_header_slot_context_11);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (1015:20) {#if hasFooter}
function create_if_block_124(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_11);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_11, get_footer_slot_context_11);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (1024:16) {#if hasAfter}
function create_if_block_120(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_11);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_122(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_121(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_11);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_11);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_11, get_after_start_slot_context_11);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_122(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_121(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_11, get_after_slot_context_11);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_11, get_after_end_slot_context_11);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (1027:20) {#if typeof after !== 'undefined'}
function create_if_block_122(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (1030:20) {#if typeof badge !== 'undefined'}
function create_if_block_121(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (1031:22) <Badge color={badgeColor}>
function create_default_slot_11(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (1038:16) {#if !(swipeout || accordionItem)}
function create_if_block_119(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (952:16) {#if hasHeader}
function create_if_block_118(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_10);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_10, get_header_slot_context_10);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (960:18) {#if (hasTitle)}
function create_if_block_117(ctx) {
	let div;
	let t0_value = plainText(/*title*/ ctx[1]) + "";
	let t0;
	let t1;
	let current;
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_10);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (title_slot) title_slot.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (title_slot) {
				title_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*title*/ 2) && t0_value !== (t0_value = plainText(/*title*/ ctx[1]) + "")) set_data(t0, t0_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_10, get_title_slot_context_10);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(title_slot, local);
			current = true;
		},
		o(local) {
			transition_out(title_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (title_slot) title_slot.d(detaching);
		}
	};
}

// (967:18) {#if hasAfter}
function create_if_block_114(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_10);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_116(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_115(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_10);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_10);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_10, get_after_start_slot_context_10);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_116(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_115(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_10, get_after_slot_context_10);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_10, get_after_end_slot_context_10);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (970:22) {#if typeof after !== 'undefined'}
function create_if_block_116(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (973:22) {#if typeof badge !== 'undefined'}
function create_if_block_115(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (974:24) <Badge color={badgeColor}>
function create_default_slot_10(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (981:16) {#if hasSubtitle}
function create_if_block_113(ctx) {
	let div;
	let t0_value = plainText(/*subtitle*/ ctx[4]) + "";
	let t0;
	let t1;
	let current;
	const subtitle_slot_template = /*#slots*/ ctx[68].subtitle;
	const subtitle_slot = create_slot(subtitle_slot_template, ctx, /*$$scope*/ ctx[82], get_subtitle_slot_context_5);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (subtitle_slot) subtitle_slot.c();
			attr(div, "class", "item-subtitle");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (subtitle_slot) {
				subtitle_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*subtitle*/ 16) && t0_value !== (t0_value = plainText(/*subtitle*/ ctx[4]) + "")) set_data(t0, t0_value);

			if (subtitle_slot) {
				if (subtitle_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(subtitle_slot, subtitle_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_subtitle_slot_changes_5, get_subtitle_slot_context_5);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(subtitle_slot, local);
			current = true;
		},
		o(local) {
			transition_out(subtitle_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (subtitle_slot) subtitle_slot.d(detaching);
		}
	};
}

// (987:16) {#if hasText}
function create_if_block_112(ctx) {
	let div;
	let t0_value = plainText(/*text*/ ctx[2]) + "";
	let t0;
	let t1;
	let current;
	const text_slot_template = /*#slots*/ ctx[68].text;
	const text_slot = create_slot(text_slot_template, ctx, /*$$scope*/ ctx[82], get_text_slot_context_5);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (text_slot) text_slot.c();
			attr(div, "class", "item-text");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (text_slot) {
				text_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*text*/ 4) && t0_value !== (t0_value = plainText(/*text*/ ctx[2]) + "")) set_data(t0, t0_value);

			if (text_slot) {
				if (text_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(text_slot, text_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_text_slot_changes_5, get_text_slot_context_5);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(text_slot, local);
			current = true;
		},
		o(local) {
			transition_out(text_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (text_slot) text_slot.d(detaching);
		}
	};
}

// (994:16) {#if !(swipeout || accordionItem)}
function create_if_block_111(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (997:16) {#if hasFooter}
function create_if_block_110(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_10);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_10, get_footer_slot_context_10);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (814:12) {#if isSortable && sortable !== false && isSortableOpposite}
function create_if_block_108(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "sortable-handler");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (829:12) {#if hasMedia}
function create_if_block_106(ctx) {
	let div;
	let t;
	let current;
	let if_block = typeof /*media*/ ctx[3] !== "undefined" && create_if_block_107(ctx);
	const media_slot_template = /*#slots*/ ctx[68].media;
	const media_slot = create_slot(media_slot_template, ctx, /*$$scope*/ ctx[82], get_media_slot_context_4);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			if (media_slot) media_slot.c();
			attr(div, "class", "item-media");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			append(div, t);

			if (media_slot) {
				media_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (typeof /*media*/ ctx[3] !== "undefined") {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_107(ctx);
					if_block.c();
					if_block.m(div, t);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (media_slot) {
				if (media_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(media_slot, media_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_media_slot_changes_4, get_media_slot_context_4);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(media_slot, local);
			current = true;
		},
		o(local) {
			transition_out(media_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			if (media_slot) media_slot.d(detaching);
		}
	};
}

// (831:16) {#if typeof media !== 'undefined'}
function create_if_block_107(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (img.src !== (img_src_value = /*media*/ ctx[3])) attr(img, "src", img_src_value);
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*media*/ 8 && img.src !== (img_src_value = /*media*/ ctx[3])) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (891:14) {:else}
function create_else_block_8(ctx) {
	let t0;
	let t1;
	let t2;
	let t3;
	let t4;
	let if_block2_anchor;
	let current;
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_9);
	let if_block0 = (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) && create_if_block_103(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_9);
	let if_block1 = /*hasAfter*/ ctx[45] && create_if_block_100(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_9);
	let if_block2 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_99(ctx);

	return {
		c() {
			if (before_title_slot) before_title_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (after_title_slot) after_title_slot.c();
			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			if (inner_slot) inner_slot.c();
			t4 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
		},
		m(target, anchor) {
			if (before_title_slot) {
				before_title_slot.m(target, anchor);
			}

			insert(target, t0, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t1, anchor);

			if (after_title_slot) {
				after_title_slot.m(target, anchor);
			}

			insert(target, t2, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t3, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t4, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_9, get_before_title_slot_context_9);
				}
			}

			if (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasTitle, hasHeader, hasFooter*/ 3584) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_103(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t1.parentNode, t1);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_9, get_after_title_slot_context_9);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_100(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t3.parentNode, t3);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_9, get_inner_slot_context_9);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_99(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(before_title_slot, local);
			transition_in(if_block0);
			transition_in(after_title_slot, local);
			transition_in(if_block1);
			transition_in(inner_slot, local);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(before_title_slot, local);
			transition_out(if_block0);
			transition_out(after_title_slot, local);
			transition_out(if_block1);
			transition_out(inner_slot, local);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (before_title_slot) before_title_slot.d(detaching);
			if (detaching) detach(t0);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t1);
			if (after_title_slot) after_title_slot.d(detaching);
			if (detaching) detach(t2);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t3);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t4);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

// (839:14) {#if isMedia}
function create_if_block_89(ctx) {
	let t0;
	let div;
	let t1;
	let t2;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let t8;
	let if_block6_anchor;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_98(ctx);
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_8);
	let if_block1 = /*hasTitle*/ ctx[40] && create_if_block_97(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_8);
	let if_block2 = /*hasAfter*/ ctx[45] && create_if_block_94(ctx);
	let if_block3 = /*hasSubtitle*/ ctx[43] && create_if_block_93(ctx);
	let if_block4 = /*hasText*/ ctx[44] && create_if_block_92(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_8);
	let if_block5 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_91(ctx);
	let if_block6 = /*hasFooter*/ ctx[42] && create_if_block_90(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			div = element("div");
			if (before_title_slot) before_title_slot.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_title_slot) after_title_slot.c();
			t3 = space();
			if (if_block2) if_block2.c();
			t4 = space();
			if (if_block3) if_block3.c();
			t5 = space();
			if (if_block4) if_block4.c();
			t6 = space();
			if (inner_slot) inner_slot.c();
			t7 = space();
			if (if_block5) if_block5.c();
			t8 = space();
			if (if_block6) if_block6.c();
			if_block6_anchor = empty();
			attr(div, "class", "item-title-row");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			insert(target, div, anchor);

			if (before_title_slot) {
				before_title_slot.m(div, null);
			}

			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_title_slot) {
				after_title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block2) if_block2.m(div, null);
			insert(target, t4, anchor);
			if (if_block3) if_block3.m(target, anchor);
			insert(target, t5, anchor);
			if (if_block4) if_block4.m(target, anchor);
			insert(target, t6, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t7, anchor);
			if (if_block5) if_block5.m(target, anchor);
			insert(target, t8, anchor);
			if (if_block6) if_block6.m(target, anchor);
			insert(target, if_block6_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_98(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_8, get_before_title_slot_context_8);
				}
			}

			if (/*hasTitle*/ ctx[40]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasTitle*/ 512) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_97(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_8, get_after_title_slot_context_8);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_94(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*hasSubtitle*/ ctx[43]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty[1] & /*hasSubtitle*/ 4096) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block_93(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(t5.parentNode, t5);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (/*hasText*/ ctx[44]) {
				if (if_block4) {
					if_block4.p(ctx, dirty);

					if (dirty[1] & /*hasText*/ 8192) {
						transition_in(if_block4, 1);
					}
				} else {
					if_block4 = create_if_block_92(ctx);
					if_block4.c();
					transition_in(if_block4, 1);
					if_block4.m(t6.parentNode, t6);
				}
			} else if (if_block4) {
				group_outros();

				transition_out(if_block4, 1, 1, () => {
					if_block4 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_8, get_inner_slot_context_8);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block5) {
					if_block5.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block5, 1);
					}
				} else {
					if_block5 = create_if_block_91(ctx);
					if_block5.c();
					transition_in(if_block5, 1);
					if_block5.m(t8.parentNode, t8);
				}
			} else if (if_block5) {
				group_outros();

				transition_out(if_block5, 1, 1, () => {
					if_block5 = null;
				});

				check_outros();
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block6) {
					if_block6.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block6, 1);
					}
				} else {
					if_block6 = create_if_block_90(ctx);
					if_block6.c();
					transition_in(if_block6, 1);
					if_block6.m(if_block6_anchor.parentNode, if_block6_anchor);
				}
			} else if (if_block6) {
				group_outros();

				transition_out(if_block6, 1, 1, () => {
					if_block6 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(before_title_slot, local);
			transition_in(if_block1);
			transition_in(after_title_slot, local);
			transition_in(if_block2);
			transition_in(if_block3);
			transition_in(if_block4);
			transition_in(inner_slot, local);
			transition_in(if_block5);
			transition_in(if_block6);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(before_title_slot, local);
			transition_out(if_block1);
			transition_out(after_title_slot, local);
			transition_out(if_block2);
			transition_out(if_block3);
			transition_out(if_block4);
			transition_out(inner_slot, local);
			transition_out(if_block5);
			transition_out(if_block6);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (before_title_slot) before_title_slot.d(detaching);
			if (if_block1) if_block1.d();
			if (after_title_slot) after_title_slot.d(detaching);
			if (if_block2) if_block2.d();
			if (detaching) detach(t4);
			if (if_block3) if_block3.d(detaching);
			if (detaching) detach(t5);
			if (if_block4) if_block4.d(detaching);
			if (detaching) detach(t6);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t7);
			if (if_block5) if_block5.d(detaching);
			if (detaching) detach(t8);
			if (if_block6) if_block6.d(detaching);
			if (detaching) detach(if_block6_anchor);
		}
	};
}

// (893:16) {#if (hasTitle || hasHeader || hasFooter)}
function create_if_block_103(ctx) {
	let div;
	let t0;
	let t1_value = plainText(/*title*/ ctx[1]) + "";
	let t1;
	let t2;
	let t3;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_105(ctx);
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_9);
	let if_block1 = /*hasFooter*/ ctx[42] && create_if_block_104(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			t1 = text_1(t1_value);
			t2 = space();
			if (title_slot) title_slot.c();
			t3 = space();
			if (if_block1) if_block1.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t0);
			append(div, t1);
			append(div, t2);

			if (title_slot) {
				title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block1) if_block1.m(div, null);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_105(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if ((!current || dirty[0] & /*title*/ 2) && t1_value !== (t1_value = plainText(/*title*/ ctx[1]) + "")) set_data(t1, t1_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_9, get_title_slot_context_9);
				}
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_104(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(title_slot, local);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(title_slot, local);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (title_slot) title_slot.d(detaching);
			if (if_block1) if_block1.d();
		}
	};
}

// (895:20) {#if hasHeader}
function create_if_block_105(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_9);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_9, get_header_slot_context_9);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (903:20) {#if hasFooter}
function create_if_block_104(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_9);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_9, get_footer_slot_context_9);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (912:16) {#if hasAfter}
function create_if_block_100(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_9);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_102(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_101(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_9);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_9);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_9, get_after_start_slot_context_9);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_102(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_101(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_9, get_after_slot_context_9);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_9, get_after_end_slot_context_9);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (915:20) {#if typeof after !== 'undefined'}
function create_if_block_102(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (918:20) {#if typeof badge !== 'undefined'}
function create_if_block_101(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (919:22) <Badge color={badgeColor}>
function create_default_slot_9(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (926:16) {#if !(swipeout || accordionItem)}
function create_if_block_99(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (840:16) {#if hasHeader}
function create_if_block_98(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_8);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_8, get_header_slot_context_8);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (848:18) {#if (hasTitle)}
function create_if_block_97(ctx) {
	let div;
	let t0_value = plainText(/*title*/ ctx[1]) + "";
	let t0;
	let t1;
	let current;
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_8);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (title_slot) title_slot.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (title_slot) {
				title_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*title*/ 2) && t0_value !== (t0_value = plainText(/*title*/ ctx[1]) + "")) set_data(t0, t0_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_8, get_title_slot_context_8);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(title_slot, local);
			current = true;
		},
		o(local) {
			transition_out(title_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (title_slot) title_slot.d(detaching);
		}
	};
}

// (855:18) {#if hasAfter}
function create_if_block_94(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_8);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_96(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_95(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_8);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_8);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_8, get_after_start_slot_context_8);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_96(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_95(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_8, get_after_slot_context_8);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_8, get_after_end_slot_context_8);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (858:22) {#if typeof after !== 'undefined'}
function create_if_block_96(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (861:22) {#if typeof badge !== 'undefined'}
function create_if_block_95(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (862:24) <Badge color={badgeColor}>
function create_default_slot_8(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (869:16) {#if hasSubtitle}
function create_if_block_93(ctx) {
	let div;
	let t0_value = plainText(/*subtitle*/ ctx[4]) + "";
	let t0;
	let t1;
	let current;
	const subtitle_slot_template = /*#slots*/ ctx[68].subtitle;
	const subtitle_slot = create_slot(subtitle_slot_template, ctx, /*$$scope*/ ctx[82], get_subtitle_slot_context_4);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (subtitle_slot) subtitle_slot.c();
			attr(div, "class", "item-subtitle");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (subtitle_slot) {
				subtitle_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*subtitle*/ 16) && t0_value !== (t0_value = plainText(/*subtitle*/ ctx[4]) + "")) set_data(t0, t0_value);

			if (subtitle_slot) {
				if (subtitle_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(subtitle_slot, subtitle_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_subtitle_slot_changes_4, get_subtitle_slot_context_4);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(subtitle_slot, local);
			current = true;
		},
		o(local) {
			transition_out(subtitle_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (subtitle_slot) subtitle_slot.d(detaching);
		}
	};
}

// (875:16) {#if hasText}
function create_if_block_92(ctx) {
	let div;
	let t0_value = plainText(/*text*/ ctx[2]) + "";
	let t0;
	let t1;
	let current;
	const text_slot_template = /*#slots*/ ctx[68].text;
	const text_slot = create_slot(text_slot_template, ctx, /*$$scope*/ ctx[82], get_text_slot_context_4);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (text_slot) text_slot.c();
			attr(div, "class", "item-text");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (text_slot) {
				text_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*text*/ 4) && t0_value !== (t0_value = plainText(/*text*/ ctx[2]) + "")) set_data(t0, t0_value);

			if (text_slot) {
				if (text_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(text_slot, text_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_text_slot_changes_4, get_text_slot_context_4);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(text_slot, local);
			current = true;
		},
		o(local) {
			transition_out(text_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (text_slot) text_slot.d(detaching);
		}
	};
}

// (882:16) {#if !(swipeout || accordionItem)}
function create_if_block_91(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (885:16) {#if hasFooter}
function create_if_block_90(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_8);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_8, get_footer_slot_context_8);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (698:12) {#if isSortable && sortable !== false && isSortableOpposite}
function create_if_block_87(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "sortable-handler");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (701:12) {#if hasMedia}
function create_if_block_85(ctx) {
	let div;
	let t;
	let current;
	let if_block = typeof /*media*/ ctx[3] !== "undefined" && create_if_block_86(ctx);
	const media_slot_template = /*#slots*/ ctx[68].media;
	const media_slot = create_slot(media_slot_template, ctx, /*$$scope*/ ctx[82], get_media_slot_context_3);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			if (media_slot) media_slot.c();
			attr(div, "class", "item-media");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			append(div, t);

			if (media_slot) {
				media_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (typeof /*media*/ ctx[3] !== "undefined") {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_86(ctx);
					if_block.c();
					if_block.m(div, t);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (media_slot) {
				if (media_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(media_slot, media_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_media_slot_changes_3, get_media_slot_context_3);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(media_slot, local);
			current = true;
		},
		o(local) {
			transition_out(media_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			if (media_slot) media_slot.d(detaching);
		}
	};
}

// (703:16) {#if typeof media !== 'undefined'}
function create_if_block_86(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (img.src !== (img_src_value = /*media*/ ctx[3])) attr(img, "src", img_src_value);
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*media*/ 8 && img.src !== (img_src_value = /*media*/ ctx[3])) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (763:14) {:else}
function create_else_block_6(ctx) {
	let t0;
	let t1;
	let t2;
	let t3;
	let t4;
	let if_block2_anchor;
	let current;
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_7);
	let if_block0 = (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) && create_if_block_82(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_7);
	let if_block1 = /*hasAfter*/ ctx[45] && create_if_block_79(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_7);
	let if_block2 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_78(ctx);

	return {
		c() {
			if (before_title_slot) before_title_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (after_title_slot) after_title_slot.c();
			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			if (inner_slot) inner_slot.c();
			t4 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
		},
		m(target, anchor) {
			if (before_title_slot) {
				before_title_slot.m(target, anchor);
			}

			insert(target, t0, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t1, anchor);

			if (after_title_slot) {
				after_title_slot.m(target, anchor);
			}

			insert(target, t2, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t3, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t4, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_7, get_before_title_slot_context_7);
				}
			}

			if (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasTitle, hasHeader, hasFooter*/ 3584) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_82(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t1.parentNode, t1);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_7, get_after_title_slot_context_7);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_79(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t3.parentNode, t3);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_7, get_inner_slot_context_7);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_78(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(before_title_slot, local);
			transition_in(if_block0);
			transition_in(after_title_slot, local);
			transition_in(if_block1);
			transition_in(inner_slot, local);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(before_title_slot, local);
			transition_out(if_block0);
			transition_out(after_title_slot, local);
			transition_out(if_block1);
			transition_out(inner_slot, local);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (before_title_slot) before_title_slot.d(detaching);
			if (detaching) detach(t0);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t1);
			if (after_title_slot) after_title_slot.d(detaching);
			if (detaching) detach(t2);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t3);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t4);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

// (711:14) {#if isMedia}
function create_if_block_68(ctx) {
	let t0;
	let div;
	let t1;
	let t2;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let t8;
	let if_block6_anchor;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_77(ctx);
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_6);
	let if_block1 = /*hasTitle*/ ctx[40] && create_if_block_76(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_6);
	let if_block2 = /*hasAfter*/ ctx[45] && create_if_block_73(ctx);
	let if_block3 = /*hasSubtitle*/ ctx[43] && create_if_block_72(ctx);
	let if_block4 = /*hasText*/ ctx[44] && create_if_block_71(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_6);
	let if_block5 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_70(ctx);
	let if_block6 = /*hasFooter*/ ctx[42] && create_if_block_69(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			div = element("div");
			if (before_title_slot) before_title_slot.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_title_slot) after_title_slot.c();
			t3 = space();
			if (if_block2) if_block2.c();
			t4 = space();
			if (if_block3) if_block3.c();
			t5 = space();
			if (if_block4) if_block4.c();
			t6 = space();
			if (inner_slot) inner_slot.c();
			t7 = space();
			if (if_block5) if_block5.c();
			t8 = space();
			if (if_block6) if_block6.c();
			if_block6_anchor = empty();
			attr(div, "class", "item-title-row");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			insert(target, div, anchor);

			if (before_title_slot) {
				before_title_slot.m(div, null);
			}

			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_title_slot) {
				after_title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block2) if_block2.m(div, null);
			insert(target, t4, anchor);
			if (if_block3) if_block3.m(target, anchor);
			insert(target, t5, anchor);
			if (if_block4) if_block4.m(target, anchor);
			insert(target, t6, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t7, anchor);
			if (if_block5) if_block5.m(target, anchor);
			insert(target, t8, anchor);
			if (if_block6) if_block6.m(target, anchor);
			insert(target, if_block6_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_77(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_6, get_before_title_slot_context_6);
				}
			}

			if (/*hasTitle*/ ctx[40]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasTitle*/ 512) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_76(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_6, get_after_title_slot_context_6);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_73(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*hasSubtitle*/ ctx[43]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty[1] & /*hasSubtitle*/ 4096) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block_72(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(t5.parentNode, t5);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (/*hasText*/ ctx[44]) {
				if (if_block4) {
					if_block4.p(ctx, dirty);

					if (dirty[1] & /*hasText*/ 8192) {
						transition_in(if_block4, 1);
					}
				} else {
					if_block4 = create_if_block_71(ctx);
					if_block4.c();
					transition_in(if_block4, 1);
					if_block4.m(t6.parentNode, t6);
				}
			} else if (if_block4) {
				group_outros();

				transition_out(if_block4, 1, 1, () => {
					if_block4 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_6, get_inner_slot_context_6);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block5) {
					if_block5.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block5, 1);
					}
				} else {
					if_block5 = create_if_block_70(ctx);
					if_block5.c();
					transition_in(if_block5, 1);
					if_block5.m(t8.parentNode, t8);
				}
			} else if (if_block5) {
				group_outros();

				transition_out(if_block5, 1, 1, () => {
					if_block5 = null;
				});

				check_outros();
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block6) {
					if_block6.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block6, 1);
					}
				} else {
					if_block6 = create_if_block_69(ctx);
					if_block6.c();
					transition_in(if_block6, 1);
					if_block6.m(if_block6_anchor.parentNode, if_block6_anchor);
				}
			} else if (if_block6) {
				group_outros();

				transition_out(if_block6, 1, 1, () => {
					if_block6 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(before_title_slot, local);
			transition_in(if_block1);
			transition_in(after_title_slot, local);
			transition_in(if_block2);
			transition_in(if_block3);
			transition_in(if_block4);
			transition_in(inner_slot, local);
			transition_in(if_block5);
			transition_in(if_block6);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(before_title_slot, local);
			transition_out(if_block1);
			transition_out(after_title_slot, local);
			transition_out(if_block2);
			transition_out(if_block3);
			transition_out(if_block4);
			transition_out(inner_slot, local);
			transition_out(if_block5);
			transition_out(if_block6);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (before_title_slot) before_title_slot.d(detaching);
			if (if_block1) if_block1.d();
			if (after_title_slot) after_title_slot.d(detaching);
			if (if_block2) if_block2.d();
			if (detaching) detach(t4);
			if (if_block3) if_block3.d(detaching);
			if (detaching) detach(t5);
			if (if_block4) if_block4.d(detaching);
			if (detaching) detach(t6);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t7);
			if (if_block5) if_block5.d(detaching);
			if (detaching) detach(t8);
			if (if_block6) if_block6.d(detaching);
			if (detaching) detach(if_block6_anchor);
		}
	};
}

// (765:16) {#if (hasTitle || hasHeader || hasFooter)}
function create_if_block_82(ctx) {
	let div;
	let t0;
	let t1_value = plainText(/*title*/ ctx[1]) + "";
	let t1;
	let t2;
	let t3;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_84(ctx);
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_7);
	let if_block1 = /*hasFooter*/ ctx[42] && create_if_block_83(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			t1 = text_1(t1_value);
			t2 = space();
			if (title_slot) title_slot.c();
			t3 = space();
			if (if_block1) if_block1.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t0);
			append(div, t1);
			append(div, t2);

			if (title_slot) {
				title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block1) if_block1.m(div, null);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_84(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if ((!current || dirty[0] & /*title*/ 2) && t1_value !== (t1_value = plainText(/*title*/ ctx[1]) + "")) set_data(t1, t1_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_7, get_title_slot_context_7);
				}
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_83(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(title_slot, local);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(title_slot, local);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (title_slot) title_slot.d(detaching);
			if (if_block1) if_block1.d();
		}
	};
}

// (767:20) {#if hasHeader}
function create_if_block_84(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_7);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_7, get_header_slot_context_7);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (775:20) {#if hasFooter}
function create_if_block_83(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_7);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_7, get_footer_slot_context_7);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (784:16) {#if hasAfter}
function create_if_block_79(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_7);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_81(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_80(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_7);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_7);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_7, get_after_start_slot_context_7);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_81(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_80(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_7, get_after_slot_context_7);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_7, get_after_end_slot_context_7);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (787:20) {#if typeof after !== 'undefined'}
function create_if_block_81(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (790:20) {#if typeof badge !== 'undefined'}
function create_if_block_80(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (791:22) <Badge color={badgeColor}>
function create_default_slot_7(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (798:16) {#if !(swipeout || accordionItem)}
function create_if_block_78(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (712:16) {#if hasHeader}
function create_if_block_77(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_6);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_6, get_header_slot_context_6);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (720:18) {#if (hasTitle)}
function create_if_block_76(ctx) {
	let div;
	let t0_value = plainText(/*title*/ ctx[1]) + "";
	let t0;
	let t1;
	let current;
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_6);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (title_slot) title_slot.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (title_slot) {
				title_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*title*/ 2) && t0_value !== (t0_value = plainText(/*title*/ ctx[1]) + "")) set_data(t0, t0_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_6, get_title_slot_context_6);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(title_slot, local);
			current = true;
		},
		o(local) {
			transition_out(title_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (title_slot) title_slot.d(detaching);
		}
	};
}

// (727:18) {#if hasAfter}
function create_if_block_73(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_6);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_75(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_74(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_6);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_6);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_6, get_after_start_slot_context_6);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_75(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_74(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_6, get_after_slot_context_6);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_6, get_after_end_slot_context_6);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (730:22) {#if typeof after !== 'undefined'}
function create_if_block_75(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (733:22) {#if typeof badge !== 'undefined'}
function create_if_block_74(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (734:24) <Badge color={badgeColor}>
function create_default_slot_6(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (741:16) {#if hasSubtitle}
function create_if_block_72(ctx) {
	let div;
	let t0_value = plainText(/*subtitle*/ ctx[4]) + "";
	let t0;
	let t1;
	let current;
	const subtitle_slot_template = /*#slots*/ ctx[68].subtitle;
	const subtitle_slot = create_slot(subtitle_slot_template, ctx, /*$$scope*/ ctx[82], get_subtitle_slot_context_3);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (subtitle_slot) subtitle_slot.c();
			attr(div, "class", "item-subtitle");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (subtitle_slot) {
				subtitle_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*subtitle*/ 16) && t0_value !== (t0_value = plainText(/*subtitle*/ ctx[4]) + "")) set_data(t0, t0_value);

			if (subtitle_slot) {
				if (subtitle_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(subtitle_slot, subtitle_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_subtitle_slot_changes_3, get_subtitle_slot_context_3);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(subtitle_slot, local);
			current = true;
		},
		o(local) {
			transition_out(subtitle_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (subtitle_slot) subtitle_slot.d(detaching);
		}
	};
}

// (747:16) {#if hasText}
function create_if_block_71(ctx) {
	let div;
	let t0_value = plainText(/*text*/ ctx[2]) + "";
	let t0;
	let t1;
	let current;
	const text_slot_template = /*#slots*/ ctx[68].text;
	const text_slot = create_slot(text_slot_template, ctx, /*$$scope*/ ctx[82], get_text_slot_context_3);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (text_slot) text_slot.c();
			attr(div, "class", "item-text");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (text_slot) {
				text_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*text*/ 4) && t0_value !== (t0_value = plainText(/*text*/ ctx[2]) + "")) set_data(t0, t0_value);

			if (text_slot) {
				if (text_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(text_slot, text_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_text_slot_changes_3, get_text_slot_context_3);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(text_slot, local);
			current = true;
		},
		o(local) {
			transition_out(text_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (text_slot) text_slot.d(detaching);
		}
	};
}

// (754:16) {#if !(swipeout || accordionItem)}
function create_if_block_70(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (757:16) {#if hasFooter}
function create_if_block_69(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_6);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_6, get_footer_slot_context_6);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (450:8) {:else}
function create_else_block_2(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_26, create_else_block_4];
	const if_blocks = [];

	function select_block_type_4(ctx, dirty) {
		if (/*checkbox*/ ctx[17] || /*radio*/ ctx[18]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_4(ctx, [-1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_4(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (334:8) {#if isLink}
function create_if_block_5(ctx) {
	let a;
	let div1;
	let t0;
	let t1;
	let t2;
	let div0;
	let t3;
	let current_block_type_index;
	let if_block2;
	let t4;
	let t5;
	let t6;
	let useRouteProps_action;
	let current;
	let mounted;
	let dispose;
	const content_start_slot_template = /*#slots*/ ctx[68]["content-start"];
	const content_start_slot = create_slot(content_start_slot_template, ctx, /*$$scope*/ ctx[82], get_content_start_slot_context);
	let if_block0 = /*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32] && create_if_block_25(ctx);
	let if_block1 = /*hasMedia*/ ctx[39] && create_if_block_23(ctx);
	const inner_start_slot_template = /*#slots*/ ctx[68]["inner-start"];
	const inner_start_slot = create_slot(inner_start_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_start_slot_context);
	const if_block_creators = [create_if_block_6, create_else_block_1];
	const if_blocks = [];

	function select_block_type_3(ctx, dirty) {
		if (/*isMedia*/ ctx[30]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_3(ctx, [-1]);
	if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	const inner_end_slot_template = /*#slots*/ ctx[68]["inner-end"];
	const inner_end_slot = create_slot(inner_end_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_end_slot_context);
	const content_slot_template = /*#slots*/ ctx[68].content;
	const content_slot = create_slot(content_slot_template, ctx, /*$$scope*/ ctx[82], get_content_slot_context);
	const content_end_slot_template = /*#slots*/ ctx[68]["content-end"];
	const content_end_slot = create_slot(content_end_slot_template, ctx, /*$$scope*/ ctx[82], get_content_end_slot_context);
	let a_levels = [{ class: /*linkClasses*/ ctx[36] }, /*linkAttrs*/ ctx[37]];
	let a_data = {};

	for (let i = 0; i < a_levels.length; i += 1) {
		a_data = assign(a_data, a_levels[i]);
	}

	return {
		c() {
			a = element("a");
			div1 = element("div");
			if (content_start_slot) content_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			div0 = element("div");
			if (inner_start_slot) inner_start_slot.c();
			t3 = space();
			if_block2.c();
			t4 = space();
			if (inner_end_slot) inner_end_slot.c();
			t5 = space();
			if (content_slot) content_slot.c();
			t6 = space();
			if (content_end_slot) content_end_slot.c();
			attr(div0, "class", "item-inner");
			attr(div1, "class", /*contentClasses*/ ctx[35]);
			set_attributes(a, a_data);
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, div1);

			if (content_start_slot) {
				content_start_slot.m(div1, null);
			}

			append(div1, t0);
			if (if_block0) if_block0.m(div1, null);
			append(div1, t1);
			if (if_block1) if_block1.m(div1, null);
			append(div1, t2);
			append(div1, div0);

			if (inner_start_slot) {
				inner_start_slot.m(div0, null);
			}

			append(div0, t3);
			if_blocks[current_block_type_index].m(div0, null);
			append(div0, t4);

			if (inner_end_slot) {
				inner_end_slot.m(div0, null);
			}

			/*div0_binding*/ ctx[71](div0);
			append(div1, t5);

			if (content_slot) {
				content_slot.m(div1, null);
			}

			append(div1, t6);

			if (content_end_slot) {
				content_end_slot.m(div1, null);
			}

			/*a_binding*/ ctx[72](a);
			current = true;

			if (!mounted) {
				dispose = [
					action_destroyer(useRouteProps_action = useRouteProps.call(null, a, /*routeProps*/ ctx[25])),
					listen(a, "click", /*onClick*/ ctx[46])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (content_start_slot) {
				if (content_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_start_slot, content_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_start_slot_changes, get_content_start_slot_context);
				}
			}

			if (/*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32]) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_25(ctx);
					if_block0.c();
					if_block0.m(div1, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*hasMedia*/ ctx[39]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasMedia*/ 256) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_23(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_start_slot) {
				if (inner_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_start_slot, inner_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_start_slot_changes, get_inner_start_slot_context);
				}
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_3(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block2 = if_blocks[current_block_type_index];

				if (!if_block2) {
					if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block2.c();
				}

				transition_in(if_block2, 1);
				if_block2.m(div0, t4);
			}

			if (inner_end_slot) {
				if (inner_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_end_slot, inner_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_end_slot_changes, get_inner_end_slot_context);
				}
			}

			if (content_slot) {
				if (content_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_slot, content_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_slot_changes, get_content_slot_context);
				}
			}

			if (content_end_slot) {
				if (content_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_end_slot, content_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_end_slot_changes, get_content_end_slot_context);
				}
			}

			if (!current || dirty[1] & /*contentClasses*/ 16) {
				attr(div1, "class", /*contentClasses*/ ctx[35]);
			}

			set_attributes(a, a_data = get_spread_update(a_levels, [
				(!current || dirty[1] & /*linkClasses*/ 32) && { class: /*linkClasses*/ ctx[36] },
				dirty[1] & /*linkAttrs*/ 64 && /*linkAttrs*/ ctx[37]
			]));

			if (useRouteProps_action && is_function(useRouteProps_action.update) && dirty[0] & /*routeProps*/ 33554432) useRouteProps_action.update.call(null, /*routeProps*/ ctx[25]);
		},
		i(local) {
			if (current) return;
			transition_in(content_start_slot, local);
			transition_in(if_block1);
			transition_in(inner_start_slot, local);
			transition_in(if_block2);
			transition_in(inner_end_slot, local);
			transition_in(content_slot, local);
			transition_in(content_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(content_start_slot, local);
			transition_out(if_block1);
			transition_out(inner_start_slot, local);
			transition_out(if_block2);
			transition_out(inner_end_slot, local);
			transition_out(content_slot, local);
			transition_out(content_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(a);
			if (content_start_slot) content_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (inner_start_slot) inner_start_slot.d(detaching);
			if_blocks[current_block_type_index].d();
			if (inner_end_slot) inner_end_slot.d(detaching);
			/*div0_binding*/ ctx[71](null);
			if (content_slot) content_slot.d(detaching);
			if (content_end_slot) content_end_slot.d(detaching);
			/*a_binding*/ ctx[72](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (576:10) {:else}
function create_else_block_4(ctx) {
	let div1;
	let t0;
	let t1;
	let t2;
	let div0;
	let t3;
	let current_block_type_index;
	let if_block2;
	let t4;
	let t5;
	let t6;
	let current;
	let mounted;
	let dispose;
	const content_start_slot_template = /*#slots*/ ctx[68]["content-start"];
	const content_start_slot = create_slot(content_start_slot_template, ctx, /*$$scope*/ ctx[82], get_content_start_slot_context_2);
	let if_block0 = /*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32] && create_if_block_66(ctx);
	let if_block1 = /*hasMedia*/ ctx[39] && create_if_block_64(ctx);
	const inner_start_slot_template = /*#slots*/ ctx[68]["inner-start"];
	const inner_start_slot = create_slot(inner_start_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_start_slot_context_2);
	const if_block_creators = [create_if_block_47, create_else_block_5];
	const if_blocks = [];

	function select_block_type_6(ctx, dirty) {
		if (/*isMedia*/ ctx[30]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_6(ctx, [-1]);
	if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	const inner_end_slot_template = /*#slots*/ ctx[68]["inner-end"];
	const inner_end_slot = create_slot(inner_end_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_end_slot_context_2);
	const content_slot_template = /*#slots*/ ctx[68].content;
	const content_slot = create_slot(content_slot_template, ctx, /*$$scope*/ ctx[82], get_content_slot_context_2);
	const content_end_slot_template = /*#slots*/ ctx[68]["content-end"];
	const content_end_slot = create_slot(content_end_slot_template, ctx, /*$$scope*/ ctx[82], get_content_end_slot_context_2);

	return {
		c() {
			div1 = element("div");
			if (content_start_slot) content_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			div0 = element("div");
			if (inner_start_slot) inner_start_slot.c();
			t3 = space();
			if_block2.c();
			t4 = space();
			if (inner_end_slot) inner_end_slot.c();
			t5 = space();
			if (content_slot) content_slot.c();
			t6 = space();
			if (content_end_slot) content_end_slot.c();
			attr(div0, "class", "item-inner");
			attr(div1, "class", /*contentClasses*/ ctx[35]);
		},
		m(target, anchor) {
			insert(target, div1, anchor);

			if (content_start_slot) {
				content_start_slot.m(div1, null);
			}

			append(div1, t0);
			if (if_block0) if_block0.m(div1, null);
			append(div1, t1);
			if (if_block1) if_block1.m(div1, null);
			append(div1, t2);
			append(div1, div0);

			if (inner_start_slot) {
				inner_start_slot.m(div0, null);
			}

			append(div0, t3);
			if_blocks[current_block_type_index].m(div0, null);
			append(div0, t4);

			if (inner_end_slot) {
				inner_end_slot.m(div0, null);
			}

			/*div0_binding_1*/ ctx[75](div0);
			append(div1, t5);

			if (content_slot) {
				content_slot.m(div1, null);
			}

			append(div1, t6);

			if (content_end_slot) {
				content_end_slot.m(div1, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(div1, "click", /*onClick*/ ctx[46]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (content_start_slot) {
				if (content_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_start_slot, content_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_start_slot_changes_2, get_content_start_slot_context_2);
				}
			}

			if (/*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32]) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_66(ctx);
					if_block0.c();
					if_block0.m(div1, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*hasMedia*/ ctx[39]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasMedia*/ 256) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_64(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_start_slot) {
				if (inner_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_start_slot, inner_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_start_slot_changes_2, get_inner_start_slot_context_2);
				}
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_6(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block2 = if_blocks[current_block_type_index];

				if (!if_block2) {
					if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block2.c();
				}

				transition_in(if_block2, 1);
				if_block2.m(div0, t4);
			}

			if (inner_end_slot) {
				if (inner_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_end_slot, inner_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_end_slot_changes_2, get_inner_end_slot_context_2);
				}
			}

			if (content_slot) {
				if (content_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_slot, content_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_slot_changes_2, get_content_slot_context_2);
				}
			}

			if (content_end_slot) {
				if (content_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_end_slot, content_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_end_slot_changes_2, get_content_end_slot_context_2);
				}
			}

			if (!current || dirty[1] & /*contentClasses*/ 16) {
				attr(div1, "class", /*contentClasses*/ ctx[35]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(content_start_slot, local);
			transition_in(if_block1);
			transition_in(inner_start_slot, local);
			transition_in(if_block2);
			transition_in(inner_end_slot, local);
			transition_in(content_slot, local);
			transition_in(content_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(content_start_slot, local);
			transition_out(if_block1);
			transition_out(inner_start_slot, local);
			transition_out(if_block2);
			transition_out(inner_end_slot, local);
			transition_out(content_slot, local);
			transition_out(content_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (content_start_slot) content_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (inner_start_slot) inner_start_slot.d(detaching);
			if_blocks[current_block_type_index].d();
			if (inner_end_slot) inner_end_slot.d(detaching);
			/*div0_binding_1*/ ctx[75](null);
			if (content_slot) content_slot.d(detaching);
			if (content_end_slot) content_end_slot.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

// (452:10) {#if checkbox || radio}
function create_if_block_26(ctx) {
	let label;
	let t0;
	let t1;
	let input;
	let input_value_value;
	let input_type_value;
	let t2;
	let i;
	let i_class_value;
	let t3;
	let t4;
	let div;
	let t5;
	let current_block_type_index;
	let if_block2;
	let t6;
	let t7;
	let t8;
	let current;
	let mounted;
	let dispose;
	const content_start_slot_template = /*#slots*/ ctx[68]["content-start"];
	const content_start_slot = create_slot(content_start_slot_template, ctx, /*$$scope*/ ctx[82], get_content_start_slot_context_1);
	let if_block0 = /*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32] && create_if_block_46(ctx);
	let if_block1 = /*hasMedia*/ ctx[39] && create_if_block_44(ctx);
	const inner_start_slot_template = /*#slots*/ ctx[68]["inner-start"];
	const inner_start_slot = create_slot(inner_start_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_start_slot_context_1);
	const if_block_creators = [create_if_block_27, create_else_block_3];
	const if_blocks = [];

	function select_block_type_5(ctx, dirty) {
		if (/*isMedia*/ ctx[30]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_5(ctx, [-1]);
	if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	const inner_end_slot_template = /*#slots*/ ctx[68]["inner-end"];
	const inner_end_slot = create_slot(inner_end_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_end_slot_context_1);
	const content_slot_template = /*#slots*/ ctx[68].content;
	const content_slot = create_slot(content_slot_template, ctx, /*$$scope*/ ctx[82], get_content_slot_context_1);
	const content_end_slot_template = /*#slots*/ ctx[68]["content-end"];
	const content_end_slot = create_slot(content_end_slot_template, ctx, /*$$scope*/ ctx[82], get_content_end_slot_context_1);

	return {
		c() {
			label = element("label");
			if (content_start_slot) content_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			input = element("input");
			t2 = space();
			i = element("i");
			t3 = space();
			if (if_block1) if_block1.c();
			t4 = space();
			div = element("div");
			if (inner_start_slot) inner_start_slot.c();
			t5 = space();
			if_block2.c();
			t6 = space();
			if (inner_end_slot) inner_end_slot.c();
			t7 = space();
			if (content_slot) content_slot.c();
			t8 = space();
			if (content_end_slot) content_end_slot.c();

			input.value = input_value_value = typeof /*value*/ ctx[20] === "undefined"
			? ""
			: /*value*/ ctx[20];

			attr(input, "name", /*name*/ ctx[19]);
			input.checked = /*checked*/ ctx[0];
			input.readOnly = /*readonly*/ ctx[21];
			input.disabled = /*disabled*/ ctx[23];
			input.required = /*required*/ ctx[22];
			attr(input, "type", input_type_value = /*radio*/ ctx[18] ? "radio" : "checkbox");
			attr(i, "class", i_class_value = `icon icon-${/*radio*/ ctx[18] ? "radio" : "checkbox"}`);
			attr(div, "class", "item-inner");
			attr(label, "class", /*contentClasses*/ ctx[35]);
		},
		m(target, anchor) {
			insert(target, label, anchor);

			if (content_start_slot) {
				content_start_slot.m(label, null);
			}

			append(label, t0);
			if (if_block0) if_block0.m(label, null);
			append(label, t1);
			append(label, input);
			/*input_binding*/ ctx[73](input);
			append(label, t2);
			append(label, i);
			append(label, t3);
			if (if_block1) if_block1.m(label, null);
			append(label, t4);
			append(label, div);

			if (inner_start_slot) {
				inner_start_slot.m(div, null);
			}

			append(div, t5);
			if_blocks[current_block_type_index].m(div, null);
			append(div, t6);

			if (inner_end_slot) {
				inner_end_slot.m(div, null);
			}

			/*div_binding*/ ctx[74](div);
			append(label, t7);

			if (content_slot) {
				content_slot.m(label, null);
			}

			append(label, t8);

			if (content_end_slot) {
				content_end_slot.m(label, null);
			}

			current = true;

			if (!mounted) {
				dispose = [
					listen(input, "change", /*onChange*/ ctx[47]),
					listen(label, "click", /*onClick*/ ctx[46])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (content_start_slot) {
				if (content_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_start_slot, content_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_start_slot_changes_1, get_content_start_slot_context_1);
				}
			}

			if (/*isSortable*/ ctx[31] && /*sortable*/ ctx[15] !== false && /*isSortableOpposite*/ ctx[32]) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_46(ctx);
					if_block0.c();
					if_block0.m(label, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (!current || dirty[0] & /*value*/ 1048576 && input_value_value !== (input_value_value = typeof /*value*/ ctx[20] === "undefined"
			? ""
			: /*value*/ ctx[20]) && input.value !== input_value_value) {
				input.value = input_value_value;
			}

			if (!current || dirty[0] & /*name*/ 524288) {
				attr(input, "name", /*name*/ ctx[19]);
			}

			if (!current || dirty[0] & /*checked*/ 1) {
				input.checked = /*checked*/ ctx[0];
			}

			if (!current || dirty[0] & /*readonly*/ 2097152) {
				input.readOnly = /*readonly*/ ctx[21];
			}

			if (!current || dirty[0] & /*disabled*/ 8388608) {
				input.disabled = /*disabled*/ ctx[23];
			}

			if (!current || dirty[0] & /*required*/ 4194304) {
				input.required = /*required*/ ctx[22];
			}

			if (!current || dirty[0] & /*radio*/ 262144 && input_type_value !== (input_type_value = /*radio*/ ctx[18] ? "radio" : "checkbox")) {
				attr(input, "type", input_type_value);
			}

			if (!current || dirty[0] & /*radio*/ 262144 && i_class_value !== (i_class_value = `icon icon-${/*radio*/ ctx[18] ? "radio" : "checkbox"}`)) {
				attr(i, "class", i_class_value);
			}

			if (/*hasMedia*/ ctx[39]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasMedia*/ 256) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_44(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(label, t4);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_start_slot) {
				if (inner_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_start_slot, inner_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_start_slot_changes_1, get_inner_start_slot_context_1);
				}
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_5(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block2 = if_blocks[current_block_type_index];

				if (!if_block2) {
					if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block2.c();
				}

				transition_in(if_block2, 1);
				if_block2.m(div, t6);
			}

			if (inner_end_slot) {
				if (inner_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_end_slot, inner_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_end_slot_changes_1, get_inner_end_slot_context_1);
				}
			}

			if (content_slot) {
				if (content_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_slot, content_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_slot_changes_1, get_content_slot_context_1);
				}
			}

			if (content_end_slot) {
				if (content_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(content_end_slot, content_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_content_end_slot_changes_1, get_content_end_slot_context_1);
				}
			}

			if (!current || dirty[1] & /*contentClasses*/ 16) {
				attr(label, "class", /*contentClasses*/ ctx[35]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(content_start_slot, local);
			transition_in(if_block1);
			transition_in(inner_start_slot, local);
			transition_in(if_block2);
			transition_in(inner_end_slot, local);
			transition_in(content_slot, local);
			transition_in(content_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(content_start_slot, local);
			transition_out(if_block1);
			transition_out(inner_start_slot, local);
			transition_out(if_block2);
			transition_out(inner_end_slot, local);
			transition_out(content_slot, local);
			transition_out(content_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(label);
			if (content_start_slot) content_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			/*input_binding*/ ctx[73](null);
			if (if_block1) if_block1.d();
			if (inner_start_slot) inner_start_slot.d(detaching);
			if_blocks[current_block_type_index].d();
			if (inner_end_slot) inner_end_slot.d(detaching);
			/*div_binding*/ ctx[74](null);
			if (content_slot) content_slot.d(detaching);
			if (content_end_slot) content_end_slot.d(detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (579:14) {#if isSortable && sortable !== false && isSortableOpposite}
function create_if_block_66(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "sortable-handler");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (582:14) {#if hasMedia}
function create_if_block_64(ctx) {
	let div;
	let t;
	let current;
	let if_block = typeof /*media*/ ctx[3] !== "undefined" && create_if_block_65(ctx);
	const media_slot_template = /*#slots*/ ctx[68].media;
	const media_slot = create_slot(media_slot_template, ctx, /*$$scope*/ ctx[82], get_media_slot_context_2);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			if (media_slot) media_slot.c();
			attr(div, "class", "item-media");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			append(div, t);

			if (media_slot) {
				media_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (typeof /*media*/ ctx[3] !== "undefined") {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_65(ctx);
					if_block.c();
					if_block.m(div, t);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (media_slot) {
				if (media_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(media_slot, media_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_media_slot_changes_2, get_media_slot_context_2);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(media_slot, local);
			current = true;
		},
		o(local) {
			transition_out(media_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			if (media_slot) media_slot.d(detaching);
		}
	};
}

// (584:18) {#if typeof media !== 'undefined'}
function create_if_block_65(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (img.src !== (img_src_value = /*media*/ ctx[3])) attr(img, "src", img_src_value);
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*media*/ 8 && img.src !== (img_src_value = /*media*/ ctx[3])) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (644:16) {:else}
function create_else_block_5(ctx) {
	let t0;
	let t1;
	let t2;
	let t3;
	let t4;
	let if_block2_anchor;
	let current;
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_5);
	let if_block0 = (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) && create_if_block_61(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_5);
	let if_block1 = /*hasAfter*/ ctx[45] && create_if_block_58(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_5);
	let if_block2 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_57(ctx);

	return {
		c() {
			if (before_title_slot) before_title_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (after_title_slot) after_title_slot.c();
			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			if (inner_slot) inner_slot.c();
			t4 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
		},
		m(target, anchor) {
			if (before_title_slot) {
				before_title_slot.m(target, anchor);
			}

			insert(target, t0, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t1, anchor);

			if (after_title_slot) {
				after_title_slot.m(target, anchor);
			}

			insert(target, t2, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t3, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t4, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_5, get_before_title_slot_context_5);
				}
			}

			if (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasTitle, hasHeader, hasFooter*/ 3584) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_61(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t1.parentNode, t1);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_5, get_after_title_slot_context_5);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_58(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t3.parentNode, t3);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_5, get_inner_slot_context_5);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_57(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(before_title_slot, local);
			transition_in(if_block0);
			transition_in(after_title_slot, local);
			transition_in(if_block1);
			transition_in(inner_slot, local);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(before_title_slot, local);
			transition_out(if_block0);
			transition_out(after_title_slot, local);
			transition_out(if_block1);
			transition_out(inner_slot, local);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (before_title_slot) before_title_slot.d(detaching);
			if (detaching) detach(t0);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t1);
			if (after_title_slot) after_title_slot.d(detaching);
			if (detaching) detach(t2);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t3);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t4);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

// (592:16) {#if isMedia}
function create_if_block_47(ctx) {
	let t0;
	let div;
	let t1;
	let t2;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let t8;
	let if_block6_anchor;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_56(ctx);
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_4);
	let if_block1 = /*hasTitle*/ ctx[40] && create_if_block_55(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_4);
	let if_block2 = /*hasAfter*/ ctx[45] && create_if_block_52(ctx);
	let if_block3 = /*hasSubtitle*/ ctx[43] && create_if_block_51(ctx);
	let if_block4 = /*hasText*/ ctx[44] && create_if_block_50(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_4);
	let if_block5 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_49(ctx);
	let if_block6 = /*hasFooter*/ ctx[42] && create_if_block_48(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			div = element("div");
			if (before_title_slot) before_title_slot.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_title_slot) after_title_slot.c();
			t3 = space();
			if (if_block2) if_block2.c();
			t4 = space();
			if (if_block3) if_block3.c();
			t5 = space();
			if (if_block4) if_block4.c();
			t6 = space();
			if (inner_slot) inner_slot.c();
			t7 = space();
			if (if_block5) if_block5.c();
			t8 = space();
			if (if_block6) if_block6.c();
			if_block6_anchor = empty();
			attr(div, "class", "item-title-row");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			insert(target, div, anchor);

			if (before_title_slot) {
				before_title_slot.m(div, null);
			}

			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_title_slot) {
				after_title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block2) if_block2.m(div, null);
			insert(target, t4, anchor);
			if (if_block3) if_block3.m(target, anchor);
			insert(target, t5, anchor);
			if (if_block4) if_block4.m(target, anchor);
			insert(target, t6, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t7, anchor);
			if (if_block5) if_block5.m(target, anchor);
			insert(target, t8, anchor);
			if (if_block6) if_block6.m(target, anchor);
			insert(target, if_block6_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_56(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_4, get_before_title_slot_context_4);
				}
			}

			if (/*hasTitle*/ ctx[40]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasTitle*/ 512) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_55(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_4, get_after_title_slot_context_4);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_52(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*hasSubtitle*/ ctx[43]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty[1] & /*hasSubtitle*/ 4096) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block_51(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(t5.parentNode, t5);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (/*hasText*/ ctx[44]) {
				if (if_block4) {
					if_block4.p(ctx, dirty);

					if (dirty[1] & /*hasText*/ 8192) {
						transition_in(if_block4, 1);
					}
				} else {
					if_block4 = create_if_block_50(ctx);
					if_block4.c();
					transition_in(if_block4, 1);
					if_block4.m(t6.parentNode, t6);
				}
			} else if (if_block4) {
				group_outros();

				transition_out(if_block4, 1, 1, () => {
					if_block4 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_4, get_inner_slot_context_4);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block5) {
					if_block5.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block5, 1);
					}
				} else {
					if_block5 = create_if_block_49(ctx);
					if_block5.c();
					transition_in(if_block5, 1);
					if_block5.m(t8.parentNode, t8);
				}
			} else if (if_block5) {
				group_outros();

				transition_out(if_block5, 1, 1, () => {
					if_block5 = null;
				});

				check_outros();
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block6) {
					if_block6.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block6, 1);
					}
				} else {
					if_block6 = create_if_block_48(ctx);
					if_block6.c();
					transition_in(if_block6, 1);
					if_block6.m(if_block6_anchor.parentNode, if_block6_anchor);
				}
			} else if (if_block6) {
				group_outros();

				transition_out(if_block6, 1, 1, () => {
					if_block6 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(before_title_slot, local);
			transition_in(if_block1);
			transition_in(after_title_slot, local);
			transition_in(if_block2);
			transition_in(if_block3);
			transition_in(if_block4);
			transition_in(inner_slot, local);
			transition_in(if_block5);
			transition_in(if_block6);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(before_title_slot, local);
			transition_out(if_block1);
			transition_out(after_title_slot, local);
			transition_out(if_block2);
			transition_out(if_block3);
			transition_out(if_block4);
			transition_out(inner_slot, local);
			transition_out(if_block5);
			transition_out(if_block6);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (before_title_slot) before_title_slot.d(detaching);
			if (if_block1) if_block1.d();
			if (after_title_slot) after_title_slot.d(detaching);
			if (if_block2) if_block2.d();
			if (detaching) detach(t4);
			if (if_block3) if_block3.d(detaching);
			if (detaching) detach(t5);
			if (if_block4) if_block4.d(detaching);
			if (detaching) detach(t6);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t7);
			if (if_block5) if_block5.d(detaching);
			if (detaching) detach(t8);
			if (if_block6) if_block6.d(detaching);
			if (detaching) detach(if_block6_anchor);
		}
	};
}

// (646:18) {#if (hasTitle || hasHeader || hasFooter)}
function create_if_block_61(ctx) {
	let div;
	let t0;
	let t1_value = plainText(/*title*/ ctx[1]) + "";
	let t1;
	let t2;
	let t3;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_63(ctx);
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_5);
	let if_block1 = /*hasFooter*/ ctx[42] && create_if_block_62(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			t1 = text_1(t1_value);
			t2 = space();
			if (title_slot) title_slot.c();
			t3 = space();
			if (if_block1) if_block1.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t0);
			append(div, t1);
			append(div, t2);

			if (title_slot) {
				title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block1) if_block1.m(div, null);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_63(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if ((!current || dirty[0] & /*title*/ 2) && t1_value !== (t1_value = plainText(/*title*/ ctx[1]) + "")) set_data(t1, t1_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_5, get_title_slot_context_5);
				}
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_62(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(title_slot, local);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(title_slot, local);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (title_slot) title_slot.d(detaching);
			if (if_block1) if_block1.d();
		}
	};
}

// (648:22) {#if hasHeader}
function create_if_block_63(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_5);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_5, get_header_slot_context_5);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (656:22) {#if hasFooter}
function create_if_block_62(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_5);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_5, get_footer_slot_context_5);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (665:18) {#if hasAfter}
function create_if_block_58(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_5);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_60(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_59(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_5);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_5);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_5, get_after_start_slot_context_5);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_60(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_59(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_5, get_after_slot_context_5);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_5, get_after_end_slot_context_5);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (668:22) {#if typeof after !== 'undefined'}
function create_if_block_60(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (671:22) {#if typeof badge !== 'undefined'}
function create_if_block_59(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (672:24) <Badge color={badgeColor}>
function create_default_slot_5(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (679:18) {#if !(swipeout || accordionItem)}
function create_if_block_57(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (593:18) {#if hasHeader}
function create_if_block_56(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_4);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_4, get_header_slot_context_4);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (601:20) {#if (hasTitle)}
function create_if_block_55(ctx) {
	let div;
	let t0_value = plainText(/*title*/ ctx[1]) + "";
	let t0;
	let t1;
	let current;
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_4);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (title_slot) title_slot.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (title_slot) {
				title_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*title*/ 2) && t0_value !== (t0_value = plainText(/*title*/ ctx[1]) + "")) set_data(t0, t0_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_4, get_title_slot_context_4);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(title_slot, local);
			current = true;
		},
		o(local) {
			transition_out(title_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (title_slot) title_slot.d(detaching);
		}
	};
}

// (608:20) {#if hasAfter}
function create_if_block_52(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_4);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_54(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_53(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_4);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_4);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_4, get_after_start_slot_context_4);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_54(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_53(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_4, get_after_slot_context_4);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_4, get_after_end_slot_context_4);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (611:24) {#if typeof after !== 'undefined'}
function create_if_block_54(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (614:24) {#if typeof badge !== 'undefined'}
function create_if_block_53(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (615:26) <Badge color={badgeColor}>
function create_default_slot_4(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (622:18) {#if hasSubtitle}
function create_if_block_51(ctx) {
	let div;
	let t0_value = plainText(/*subtitle*/ ctx[4]) + "";
	let t0;
	let t1;
	let current;
	const subtitle_slot_template = /*#slots*/ ctx[68].subtitle;
	const subtitle_slot = create_slot(subtitle_slot_template, ctx, /*$$scope*/ ctx[82], get_subtitle_slot_context_2);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (subtitle_slot) subtitle_slot.c();
			attr(div, "class", "item-subtitle");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (subtitle_slot) {
				subtitle_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*subtitle*/ 16) && t0_value !== (t0_value = plainText(/*subtitle*/ ctx[4]) + "")) set_data(t0, t0_value);

			if (subtitle_slot) {
				if (subtitle_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(subtitle_slot, subtitle_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_subtitle_slot_changes_2, get_subtitle_slot_context_2);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(subtitle_slot, local);
			current = true;
		},
		o(local) {
			transition_out(subtitle_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (subtitle_slot) subtitle_slot.d(detaching);
		}
	};
}

// (628:18) {#if hasText}
function create_if_block_50(ctx) {
	let div;
	let t0_value = plainText(/*text*/ ctx[2]) + "";
	let t0;
	let t1;
	let current;
	const text_slot_template = /*#slots*/ ctx[68].text;
	const text_slot = create_slot(text_slot_template, ctx, /*$$scope*/ ctx[82], get_text_slot_context_2);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (text_slot) text_slot.c();
			attr(div, "class", "item-text");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (text_slot) {
				text_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*text*/ 4) && t0_value !== (t0_value = plainText(/*text*/ ctx[2]) + "")) set_data(t0, t0_value);

			if (text_slot) {
				if (text_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(text_slot, text_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_text_slot_changes_2, get_text_slot_context_2);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(text_slot, local);
			current = true;
		},
		o(local) {
			transition_out(text_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (text_slot) text_slot.d(detaching);
		}
	};
}

// (635:18) {#if !(swipeout || accordionItem)}
function create_if_block_49(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (638:18) {#if hasFooter}
function create_if_block_48(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_4);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_4, get_footer_slot_context_4);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (455:14) {#if isSortable && sortable !== false && isSortableOpposite}
function create_if_block_46(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "sortable-handler");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (470:14) {#if hasMedia}
function create_if_block_44(ctx) {
	let div;
	let t;
	let current;
	let if_block = typeof /*media*/ ctx[3] !== "undefined" && create_if_block_45(ctx);
	const media_slot_template = /*#slots*/ ctx[68].media;
	const media_slot = create_slot(media_slot_template, ctx, /*$$scope*/ ctx[82], get_media_slot_context_1);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			if (media_slot) media_slot.c();
			attr(div, "class", "item-media");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			append(div, t);

			if (media_slot) {
				media_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (typeof /*media*/ ctx[3] !== "undefined") {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_45(ctx);
					if_block.c();
					if_block.m(div, t);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (media_slot) {
				if (media_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(media_slot, media_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_media_slot_changes_1, get_media_slot_context_1);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(media_slot, local);
			current = true;
		},
		o(local) {
			transition_out(media_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			if (media_slot) media_slot.d(detaching);
		}
	};
}

// (472:18) {#if typeof media !== 'undefined'}
function create_if_block_45(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (img.src !== (img_src_value = /*media*/ ctx[3])) attr(img, "src", img_src_value);
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*media*/ 8 && img.src !== (img_src_value = /*media*/ ctx[3])) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (532:16) {:else}
function create_else_block_3(ctx) {
	let t0;
	let t1;
	let t2;
	let t3;
	let t4;
	let if_block2_anchor;
	let current;
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_3);
	let if_block0 = (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) && create_if_block_41(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_3);
	let if_block1 = /*hasAfter*/ ctx[45] && create_if_block_38(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_3);
	let if_block2 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_37(ctx);

	return {
		c() {
			if (before_title_slot) before_title_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (after_title_slot) after_title_slot.c();
			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			if (inner_slot) inner_slot.c();
			t4 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
		},
		m(target, anchor) {
			if (before_title_slot) {
				before_title_slot.m(target, anchor);
			}

			insert(target, t0, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t1, anchor);

			if (after_title_slot) {
				after_title_slot.m(target, anchor);
			}

			insert(target, t2, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t3, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t4, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_3, get_before_title_slot_context_3);
				}
			}

			if (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasTitle, hasHeader, hasFooter*/ 3584) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_41(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t1.parentNode, t1);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_3, get_after_title_slot_context_3);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_38(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t3.parentNode, t3);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_3, get_inner_slot_context_3);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_37(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(before_title_slot, local);
			transition_in(if_block0);
			transition_in(after_title_slot, local);
			transition_in(if_block1);
			transition_in(inner_slot, local);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(before_title_slot, local);
			transition_out(if_block0);
			transition_out(after_title_slot, local);
			transition_out(if_block1);
			transition_out(inner_slot, local);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (before_title_slot) before_title_slot.d(detaching);
			if (detaching) detach(t0);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t1);
			if (after_title_slot) after_title_slot.d(detaching);
			if (detaching) detach(t2);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t3);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t4);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

// (480:16) {#if isMedia}
function create_if_block_27(ctx) {
	let t0;
	let div;
	let t1;
	let t2;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let t8;
	let if_block6_anchor;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_36(ctx);
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_2);
	let if_block1 = /*hasTitle*/ ctx[40] && create_if_block_35(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_2);
	let if_block2 = /*hasAfter*/ ctx[45] && create_if_block_32(ctx);
	let if_block3 = /*hasSubtitle*/ ctx[43] && create_if_block_31(ctx);
	let if_block4 = /*hasText*/ ctx[44] && create_if_block_30(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_2);
	let if_block5 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_29(ctx);
	let if_block6 = /*hasFooter*/ ctx[42] && create_if_block_28(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			div = element("div");
			if (before_title_slot) before_title_slot.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_title_slot) after_title_slot.c();
			t3 = space();
			if (if_block2) if_block2.c();
			t4 = space();
			if (if_block3) if_block3.c();
			t5 = space();
			if (if_block4) if_block4.c();
			t6 = space();
			if (inner_slot) inner_slot.c();
			t7 = space();
			if (if_block5) if_block5.c();
			t8 = space();
			if (if_block6) if_block6.c();
			if_block6_anchor = empty();
			attr(div, "class", "item-title-row");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			insert(target, div, anchor);

			if (before_title_slot) {
				before_title_slot.m(div, null);
			}

			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_title_slot) {
				after_title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block2) if_block2.m(div, null);
			insert(target, t4, anchor);
			if (if_block3) if_block3.m(target, anchor);
			insert(target, t5, anchor);
			if (if_block4) if_block4.m(target, anchor);
			insert(target, t6, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t7, anchor);
			if (if_block5) if_block5.m(target, anchor);
			insert(target, t8, anchor);
			if (if_block6) if_block6.m(target, anchor);
			insert(target, if_block6_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_36(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_2, get_before_title_slot_context_2);
				}
			}

			if (/*hasTitle*/ ctx[40]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasTitle*/ 512) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_35(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_2, get_after_title_slot_context_2);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_32(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*hasSubtitle*/ ctx[43]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty[1] & /*hasSubtitle*/ 4096) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block_31(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(t5.parentNode, t5);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (/*hasText*/ ctx[44]) {
				if (if_block4) {
					if_block4.p(ctx, dirty);

					if (dirty[1] & /*hasText*/ 8192) {
						transition_in(if_block4, 1);
					}
				} else {
					if_block4 = create_if_block_30(ctx);
					if_block4.c();
					transition_in(if_block4, 1);
					if_block4.m(t6.parentNode, t6);
				}
			} else if (if_block4) {
				group_outros();

				transition_out(if_block4, 1, 1, () => {
					if_block4 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_2, get_inner_slot_context_2);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block5) {
					if_block5.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block5, 1);
					}
				} else {
					if_block5 = create_if_block_29(ctx);
					if_block5.c();
					transition_in(if_block5, 1);
					if_block5.m(t8.parentNode, t8);
				}
			} else if (if_block5) {
				group_outros();

				transition_out(if_block5, 1, 1, () => {
					if_block5 = null;
				});

				check_outros();
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block6) {
					if_block6.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block6, 1);
					}
				} else {
					if_block6 = create_if_block_28(ctx);
					if_block6.c();
					transition_in(if_block6, 1);
					if_block6.m(if_block6_anchor.parentNode, if_block6_anchor);
				}
			} else if (if_block6) {
				group_outros();

				transition_out(if_block6, 1, 1, () => {
					if_block6 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(before_title_slot, local);
			transition_in(if_block1);
			transition_in(after_title_slot, local);
			transition_in(if_block2);
			transition_in(if_block3);
			transition_in(if_block4);
			transition_in(inner_slot, local);
			transition_in(if_block5);
			transition_in(if_block6);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(before_title_slot, local);
			transition_out(if_block1);
			transition_out(after_title_slot, local);
			transition_out(if_block2);
			transition_out(if_block3);
			transition_out(if_block4);
			transition_out(inner_slot, local);
			transition_out(if_block5);
			transition_out(if_block6);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (before_title_slot) before_title_slot.d(detaching);
			if (if_block1) if_block1.d();
			if (after_title_slot) after_title_slot.d(detaching);
			if (if_block2) if_block2.d();
			if (detaching) detach(t4);
			if (if_block3) if_block3.d(detaching);
			if (detaching) detach(t5);
			if (if_block4) if_block4.d(detaching);
			if (detaching) detach(t6);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t7);
			if (if_block5) if_block5.d(detaching);
			if (detaching) detach(t8);
			if (if_block6) if_block6.d(detaching);
			if (detaching) detach(if_block6_anchor);
		}
	};
}

// (534:18) {#if (hasTitle || hasHeader || hasFooter)}
function create_if_block_41(ctx) {
	let div;
	let t0;
	let t1_value = plainText(/*title*/ ctx[1]) + "";
	let t1;
	let t2;
	let t3;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_43(ctx);
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_3);
	let if_block1 = /*hasFooter*/ ctx[42] && create_if_block_42(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			t1 = text_1(t1_value);
			t2 = space();
			if (title_slot) title_slot.c();
			t3 = space();
			if (if_block1) if_block1.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t0);
			append(div, t1);
			append(div, t2);

			if (title_slot) {
				title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block1) if_block1.m(div, null);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_43(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if ((!current || dirty[0] & /*title*/ 2) && t1_value !== (t1_value = plainText(/*title*/ ctx[1]) + "")) set_data(t1, t1_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_3, get_title_slot_context_3);
				}
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_42(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(title_slot, local);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(title_slot, local);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (title_slot) title_slot.d(detaching);
			if (if_block1) if_block1.d();
		}
	};
}

// (536:22) {#if hasHeader}
function create_if_block_43(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_3);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_3, get_header_slot_context_3);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (544:22) {#if hasFooter}
function create_if_block_42(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_3);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_3, get_footer_slot_context_3);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (553:18) {#if hasAfter}
function create_if_block_38(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_3);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_40(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_39(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_3);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_3);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_3, get_after_start_slot_context_3);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_40(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_39(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_3, get_after_slot_context_3);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_3, get_after_end_slot_context_3);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (556:22) {#if typeof after !== 'undefined'}
function create_if_block_40(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (559:22) {#if typeof badge !== 'undefined'}
function create_if_block_39(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (560:24) <Badge color={badgeColor}>
function create_default_slot_3(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (567:18) {#if !(swipeout || accordionItem)}
function create_if_block_37(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (481:18) {#if hasHeader}
function create_if_block_36(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_2);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_2, get_header_slot_context_2);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (489:20) {#if (hasTitle)}
function create_if_block_35(ctx) {
	let div;
	let t0_value = plainText(/*title*/ ctx[1]) + "";
	let t0;
	let t1;
	let current;
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_2);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (title_slot) title_slot.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (title_slot) {
				title_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*title*/ 2) && t0_value !== (t0_value = plainText(/*title*/ ctx[1]) + "")) set_data(t0, t0_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_2, get_title_slot_context_2);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(title_slot, local);
			current = true;
		},
		o(local) {
			transition_out(title_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (title_slot) title_slot.d(detaching);
		}
	};
}

// (496:20) {#if hasAfter}
function create_if_block_32(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_2);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_34(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_33(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_2);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_2);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_2, get_after_start_slot_context_2);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_34(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_33(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_2, get_after_slot_context_2);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_2, get_after_end_slot_context_2);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (499:24) {#if typeof after !== 'undefined'}
function create_if_block_34(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (502:24) {#if typeof badge !== 'undefined'}
function create_if_block_33(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (503:26) <Badge color={badgeColor}>
function create_default_slot_2(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (510:18) {#if hasSubtitle}
function create_if_block_31(ctx) {
	let div;
	let t0_value = plainText(/*subtitle*/ ctx[4]) + "";
	let t0;
	let t1;
	let current;
	const subtitle_slot_template = /*#slots*/ ctx[68].subtitle;
	const subtitle_slot = create_slot(subtitle_slot_template, ctx, /*$$scope*/ ctx[82], get_subtitle_slot_context_1);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (subtitle_slot) subtitle_slot.c();
			attr(div, "class", "item-subtitle");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (subtitle_slot) {
				subtitle_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*subtitle*/ 16) && t0_value !== (t0_value = plainText(/*subtitle*/ ctx[4]) + "")) set_data(t0, t0_value);

			if (subtitle_slot) {
				if (subtitle_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(subtitle_slot, subtitle_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_subtitle_slot_changes_1, get_subtitle_slot_context_1);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(subtitle_slot, local);
			current = true;
		},
		o(local) {
			transition_out(subtitle_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (subtitle_slot) subtitle_slot.d(detaching);
		}
	};
}

// (516:18) {#if hasText}
function create_if_block_30(ctx) {
	let div;
	let t0_value = plainText(/*text*/ ctx[2]) + "";
	let t0;
	let t1;
	let current;
	const text_slot_template = /*#slots*/ ctx[68].text;
	const text_slot = create_slot(text_slot_template, ctx, /*$$scope*/ ctx[82], get_text_slot_context_1);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (text_slot) text_slot.c();
			attr(div, "class", "item-text");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (text_slot) {
				text_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*text*/ 4) && t0_value !== (t0_value = plainText(/*text*/ ctx[2]) + "")) set_data(t0, t0_value);

			if (text_slot) {
				if (text_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(text_slot, text_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_text_slot_changes_1, get_text_slot_context_1);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(text_slot, local);
			current = true;
		},
		o(local) {
			transition_out(text_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (text_slot) text_slot.d(detaching);
		}
	};
}

// (523:18) {#if !(swipeout || accordionItem)}
function create_if_block_29(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (526:18) {#if hasFooter}
function create_if_block_28(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_2);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_2, get_footer_slot_context_2);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (339:14) {#if isSortable && sortable !== false && isSortableOpposite}
function create_if_block_25(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "sortable-handler");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (342:14) {#if hasMedia}
function create_if_block_23(ctx) {
	let div;
	let t;
	let current;
	let if_block = typeof /*media*/ ctx[3] !== "undefined" && create_if_block_24(ctx);
	const media_slot_template = /*#slots*/ ctx[68].media;
	const media_slot = create_slot(media_slot_template, ctx, /*$$scope*/ ctx[82], get_media_slot_context);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t = space();
			if (media_slot) media_slot.c();
			attr(div, "class", "item-media");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			append(div, t);

			if (media_slot) {
				media_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (typeof /*media*/ ctx[3] !== "undefined") {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_24(ctx);
					if_block.c();
					if_block.m(div, t);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (media_slot) {
				if (media_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(media_slot, media_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_media_slot_changes, get_media_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(media_slot, local);
			current = true;
		},
		o(local) {
			transition_out(media_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			if (media_slot) media_slot.d(detaching);
		}
	};
}

// (344:18) {#if typeof media !== 'undefined'}
function create_if_block_24(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (img.src !== (img_src_value = /*media*/ ctx[3])) attr(img, "src", img_src_value);
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*media*/ 8 && img.src !== (img_src_value = /*media*/ ctx[3])) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (404:16) {:else}
function create_else_block_1(ctx) {
	let t0;
	let t1;
	let t2;
	let t3;
	let t4;
	let if_block2_anchor;
	let current;
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context_1);
	let if_block0 = (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) && create_if_block_20(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context_1);
	let if_block1 = /*hasAfter*/ ctx[45] && create_if_block_17(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context_1);
	let if_block2 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_16(ctx);

	return {
		c() {
			if (before_title_slot) before_title_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (after_title_slot) after_title_slot.c();
			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			if (inner_slot) inner_slot.c();
			t4 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
		},
		m(target, anchor) {
			if (before_title_slot) {
				before_title_slot.m(target, anchor);
			}

			insert(target, t0, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t1, anchor);

			if (after_title_slot) {
				after_title_slot.m(target, anchor);
			}

			insert(target, t2, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t3, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t4, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes_1, get_before_title_slot_context_1);
				}
			}

			if (/*hasTitle*/ ctx[40] || /*hasHeader*/ ctx[41] || /*hasFooter*/ ctx[42]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasTitle, hasHeader, hasFooter*/ 3584) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_20(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t1.parentNode, t1);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes_1, get_after_title_slot_context_1);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_17(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t3.parentNode, t3);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes_1, get_inner_slot_context_1);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_16(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(before_title_slot, local);
			transition_in(if_block0);
			transition_in(after_title_slot, local);
			transition_in(if_block1);
			transition_in(inner_slot, local);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(before_title_slot, local);
			transition_out(if_block0);
			transition_out(after_title_slot, local);
			transition_out(if_block1);
			transition_out(inner_slot, local);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (before_title_slot) before_title_slot.d(detaching);
			if (detaching) detach(t0);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t1);
			if (after_title_slot) after_title_slot.d(detaching);
			if (detaching) detach(t2);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t3);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t4);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

// (352:16) {#if isMedia}
function create_if_block_6(ctx) {
	let t0;
	let div;
	let t1;
	let t2;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let t8;
	let if_block6_anchor;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_15(ctx);
	const before_title_slot_template = /*#slots*/ ctx[68]["before-title"];
	const before_title_slot = create_slot(before_title_slot_template, ctx, /*$$scope*/ ctx[82], get_before_title_slot_context);
	let if_block1 = /*hasTitle*/ ctx[40] && create_if_block_14(ctx);
	const after_title_slot_template = /*#slots*/ ctx[68]["after-title"];
	const after_title_slot = create_slot(after_title_slot_template, ctx, /*$$scope*/ ctx[82], get_after_title_slot_context);
	let if_block2 = /*hasAfter*/ ctx[45] && create_if_block_11(ctx);
	let if_block3 = /*hasSubtitle*/ ctx[43] && create_if_block_10(ctx);
	let if_block4 = /*hasText*/ ctx[44] && create_if_block_9(ctx);
	const inner_slot_template = /*#slots*/ ctx[68].inner;
	const inner_slot = create_slot(inner_slot_template, ctx, /*$$scope*/ ctx[82], get_inner_slot_context);
	let if_block5 = !(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16]) && create_if_block_8(ctx);
	let if_block6 = /*hasFooter*/ ctx[42] && create_if_block_7(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			div = element("div");
			if (before_title_slot) before_title_slot.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_title_slot) after_title_slot.c();
			t3 = space();
			if (if_block2) if_block2.c();
			t4 = space();
			if (if_block3) if_block3.c();
			t5 = space();
			if (if_block4) if_block4.c();
			t6 = space();
			if (inner_slot) inner_slot.c();
			t7 = space();
			if (if_block5) if_block5.c();
			t8 = space();
			if (if_block6) if_block6.c();
			if_block6_anchor = empty();
			attr(div, "class", "item-title-row");
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			insert(target, div, anchor);

			if (before_title_slot) {
				before_title_slot.m(div, null);
			}

			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_title_slot) {
				after_title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block2) if_block2.m(div, null);
			insert(target, t4, anchor);
			if (if_block3) if_block3.m(target, anchor);
			insert(target, t5, anchor);
			if (if_block4) if_block4.m(target, anchor);
			insert(target, t6, anchor);

			if (inner_slot) {
				inner_slot.m(target, anchor);
			}

			insert(target, t7, anchor);
			if (if_block5) if_block5.m(target, anchor);
			insert(target, t8, anchor);
			if (if_block6) if_block6.m(target, anchor);
			insert(target, if_block6_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_15(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (before_title_slot) {
				if (before_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(before_title_slot, before_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_before_title_slot_changes, get_before_title_slot_context);
				}
			}

			if (/*hasTitle*/ ctx[40]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasTitle*/ 512) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_14(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_title_slot) {
				if (after_title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_title_slot, after_title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_title_slot_changes, get_after_title_slot_context);
				}
			}

			if (/*hasAfter*/ ctx[45]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[1] & /*hasAfter*/ 16384) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_11(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*hasSubtitle*/ ctx[43]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty[1] & /*hasSubtitle*/ 4096) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block_10(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(t5.parentNode, t5);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (/*hasText*/ ctx[44]) {
				if (if_block4) {
					if_block4.p(ctx, dirty);

					if (dirty[1] & /*hasText*/ 8192) {
						transition_in(if_block4, 1);
					}
				} else {
					if_block4 = create_if_block_9(ctx);
					if_block4.c();
					transition_in(if_block4, 1);
					if_block4.m(t6.parentNode, t6);
				}
			} else if (if_block4) {
				group_outros();

				transition_out(if_block4, 1, 1, () => {
					if_block4 = null;
				});

				check_outros();
			}

			if (inner_slot) {
				if (inner_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(inner_slot, inner_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_inner_slot_changes, get_inner_slot_context);
				}
			}

			if (!(/*swipeout*/ ctx[14] || /*accordionItem*/ ctx[16])) {
				if (if_block5) {
					if_block5.p(ctx, dirty);

					if (dirty[0] & /*swipeout, accordionItem*/ 81920) {
						transition_in(if_block5, 1);
					}
				} else {
					if_block5 = create_if_block_8(ctx);
					if_block5.c();
					transition_in(if_block5, 1);
					if_block5.m(t8.parentNode, t8);
				}
			} else if (if_block5) {
				group_outros();

				transition_out(if_block5, 1, 1, () => {
					if_block5 = null;
				});

				check_outros();
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block6) {
					if_block6.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block6, 1);
					}
				} else {
					if_block6 = create_if_block_7(ctx);
					if_block6.c();
					transition_in(if_block6, 1);
					if_block6.m(if_block6_anchor.parentNode, if_block6_anchor);
				}
			} else if (if_block6) {
				group_outros();

				transition_out(if_block6, 1, 1, () => {
					if_block6 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(before_title_slot, local);
			transition_in(if_block1);
			transition_in(after_title_slot, local);
			transition_in(if_block2);
			transition_in(if_block3);
			transition_in(if_block4);
			transition_in(inner_slot, local);
			transition_in(if_block5);
			transition_in(if_block6);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(before_title_slot, local);
			transition_out(if_block1);
			transition_out(after_title_slot, local);
			transition_out(if_block2);
			transition_out(if_block3);
			transition_out(if_block4);
			transition_out(inner_slot, local);
			transition_out(if_block5);
			transition_out(if_block6);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (before_title_slot) before_title_slot.d(detaching);
			if (if_block1) if_block1.d();
			if (after_title_slot) after_title_slot.d(detaching);
			if (if_block2) if_block2.d();
			if (detaching) detach(t4);
			if (if_block3) if_block3.d(detaching);
			if (detaching) detach(t5);
			if (if_block4) if_block4.d(detaching);
			if (detaching) detach(t6);
			if (inner_slot) inner_slot.d(detaching);
			if (detaching) detach(t7);
			if (if_block5) if_block5.d(detaching);
			if (detaching) detach(t8);
			if (if_block6) if_block6.d(detaching);
			if (detaching) detach(if_block6_anchor);
		}
	};
}

// (406:18) {#if (hasTitle || hasHeader || hasFooter)}
function create_if_block_20(ctx) {
	let div;
	let t0;
	let t1_value = plainText(/*title*/ ctx[1]) + "";
	let t1;
	let t2;
	let t3;
	let current;
	let if_block0 = /*hasHeader*/ ctx[41] && create_if_block_22(ctx);
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context_1);
	let if_block1 = /*hasFooter*/ ctx[42] && create_if_block_21(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			t1 = text_1(t1_value);
			t2 = space();
			if (title_slot) title_slot.c();
			t3 = space();
			if (if_block1) if_block1.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t0);
			append(div, t1);
			append(div, t2);

			if (title_slot) {
				title_slot.m(div, null);
			}

			append(div, t3);
			if (if_block1) if_block1.m(div, null);
			current = true;
		},
		p(ctx, dirty) {
			if (/*hasHeader*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[1] & /*hasHeader*/ 1024) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_22(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if ((!current || dirty[0] & /*title*/ 2) && t1_value !== (t1_value = plainText(/*title*/ ctx[1]) + "")) set_data(t1, t1_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes_1, get_title_slot_context_1);
				}
			}

			if (/*hasFooter*/ ctx[42]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[1] & /*hasFooter*/ 2048) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_21(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(title_slot, local);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(title_slot, local);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (title_slot) title_slot.d(detaching);
			if (if_block1) if_block1.d();
		}
	};
}

// (408:22) {#if hasHeader}
function create_if_block_22(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context_1);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes_1, get_header_slot_context_1);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (416:22) {#if hasFooter}
function create_if_block_21(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context_1);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes_1, get_footer_slot_context_1);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (425:18) {#if hasAfter}
function create_if_block_17(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context_1);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_19(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_18(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context_1);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context_1);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes_1, get_after_start_slot_context_1);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_19(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_18(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes_1, get_after_slot_context_1);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes_1, get_after_end_slot_context_1);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (428:22) {#if typeof after !== 'undefined'}
function create_if_block_19(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (431:22) {#if typeof badge !== 'undefined'}
function create_if_block_18(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (432:24) <Badge color={badgeColor}>
function create_default_slot_1(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (439:18) {#if !(swipeout || accordionItem)}
function create_if_block_16(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (353:18) {#if hasHeader}
function create_if_block_15(ctx) {
	let div;
	let t0_value = plainText(/*header*/ ctx[5]) + "";
	let t0;
	let t1;
	let current;
	const header_slot_template = /*#slots*/ ctx[68].header;
	const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[82], get_header_slot_context);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (header_slot) header_slot.c();
			attr(div, "class", "item-header");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (header_slot) {
				header_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*header*/ 32) && t0_value !== (t0_value = plainText(/*header*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (header_slot) {
				if (header_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(header_slot, header_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_header_slot_changes, get_header_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header_slot, local);
			current = true;
		},
		o(local) {
			transition_out(header_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (header_slot) header_slot.d(detaching);
		}
	};
}

// (361:20) {#if (hasTitle)}
function create_if_block_14(ctx) {
	let div;
	let t0_value = plainText(/*title*/ ctx[1]) + "";
	let t0;
	let t1;
	let current;
	const title_slot_template = /*#slots*/ ctx[68].title;
	const title_slot = create_slot(title_slot_template, ctx, /*$$scope*/ ctx[82], get_title_slot_context);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (title_slot) title_slot.c();
			attr(div, "class", "item-title");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (title_slot) {
				title_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*title*/ 2) && t0_value !== (t0_value = plainText(/*title*/ ctx[1]) + "")) set_data(t0, t0_value);

			if (title_slot) {
				if (title_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(title_slot, title_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_title_slot_changes, get_title_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(title_slot, local);
			current = true;
		},
		o(local) {
			transition_out(title_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (title_slot) title_slot.d(detaching);
		}
	};
}

// (368:20) {#if hasAfter}
function create_if_block_11(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let current;
	const after_start_slot_template = /*#slots*/ ctx[68]["after-start"];
	const after_start_slot = create_slot(after_start_slot_template, ctx, /*$$scope*/ ctx[82], get_after_start_slot_context);
	let if_block0 = typeof /*after*/ ctx[9] !== "undefined" && create_if_block_13(ctx);
	let if_block1 = typeof /*badge*/ ctx[10] !== "undefined" && create_if_block_12(ctx);
	const after_slot_template = /*#slots*/ ctx[68].after;
	const after_slot = create_slot(after_slot_template, ctx, /*$$scope*/ ctx[82], get_after_slot_context);
	const after_end_slot_template = /*#slots*/ ctx[68]["after-end"];
	const after_end_slot = create_slot(after_end_slot_template, ctx, /*$$scope*/ ctx[82], get_after_end_slot_context);

	return {
		c() {
			div = element("div");
			if (after_start_slot) after_start_slot.c();
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			if (after_slot) after_slot.c();
			t3 = space();
			if (after_end_slot) after_end_slot.c();
			attr(div, "class", "item-after");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (after_start_slot) {
				after_start_slot.m(div, null);
			}

			append(div, t0);
			if (if_block0) if_block0.m(div, null);
			append(div, t1);
			if (if_block1) if_block1.m(div, null);
			append(div, t2);

			if (after_slot) {
				after_slot.m(div, null);
			}

			append(div, t3);

			if (after_end_slot) {
				after_end_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (after_start_slot) {
				if (after_start_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_start_slot, after_start_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_start_slot_changes, get_after_start_slot_context);
				}
			}

			if (typeof /*after*/ ctx[9] !== "undefined") {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_13(ctx);
					if_block0.c();
					if_block0.m(div, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (typeof /*badge*/ ctx[10] !== "undefined") {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*badge*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_12(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (after_slot) {
				if (after_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_slot, after_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_slot_changes, get_after_slot_context);
				}
			}

			if (after_end_slot) {
				if (after_end_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(after_end_slot, after_end_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_after_end_slot_changes, get_after_end_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(after_start_slot, local);
			transition_in(if_block1);
			transition_in(after_slot, local);
			transition_in(after_end_slot, local);
			current = true;
		},
		o(local) {
			transition_out(after_start_slot, local);
			transition_out(if_block1);
			transition_out(after_slot, local);
			transition_out(after_end_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (after_start_slot) after_start_slot.d(detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (after_slot) after_slot.d(detaching);
			if (after_end_slot) after_end_slot.d(detaching);
		}
	};
}

// (371:24) {#if typeof after !== 'undefined'}
function create_if_block_13(ctx) {
	let span;
	let t_value = plainText(/*after*/ ctx[9]) + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*after*/ 512 && t_value !== (t_value = plainText(/*after*/ ctx[9]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (374:24) {#if typeof badge !== 'undefined'}
function create_if_block_12(ctx) {
	let badge_1;
	let current;

	badge_1 = new Badge({
			props: {
				color: /*badgeColor*/ ctx[11],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(badge_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(badge_1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const badge_1_changes = {};
			if (dirty[0] & /*badgeColor*/ 2048) badge_1_changes.color = /*badgeColor*/ ctx[11];

			if (dirty[0] & /*badge*/ 1024 | dirty[2] & /*$$scope*/ 1048576) {
				badge_1_changes.$$scope = { dirty, ctx };
			}

			badge_1.$set(badge_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(badge_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(badge_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(badge_1, detaching);
		}
	};
}

// (375:26) <Badge color={badgeColor}>
function create_default_slot(ctx) {
	let t_value = plainText(/*badge*/ ctx[10]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*badge*/ 1024 && t_value !== (t_value = plainText(/*badge*/ ctx[10]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (382:18) {#if hasSubtitle}
function create_if_block_10(ctx) {
	let div;
	let t0_value = plainText(/*subtitle*/ ctx[4]) + "";
	let t0;
	let t1;
	let current;
	const subtitle_slot_template = /*#slots*/ ctx[68].subtitle;
	const subtitle_slot = create_slot(subtitle_slot_template, ctx, /*$$scope*/ ctx[82], get_subtitle_slot_context);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (subtitle_slot) subtitle_slot.c();
			attr(div, "class", "item-subtitle");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (subtitle_slot) {
				subtitle_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*subtitle*/ 16) && t0_value !== (t0_value = plainText(/*subtitle*/ ctx[4]) + "")) set_data(t0, t0_value);

			if (subtitle_slot) {
				if (subtitle_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(subtitle_slot, subtitle_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_subtitle_slot_changes, get_subtitle_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(subtitle_slot, local);
			current = true;
		},
		o(local) {
			transition_out(subtitle_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (subtitle_slot) subtitle_slot.d(detaching);
		}
	};
}

// (388:18) {#if hasText}
function create_if_block_9(ctx) {
	let div;
	let t0_value = plainText(/*text*/ ctx[2]) + "";
	let t0;
	let t1;
	let current;
	const text_slot_template = /*#slots*/ ctx[68].text;
	const text_slot = create_slot(text_slot_template, ctx, /*$$scope*/ ctx[82], get_text_slot_context);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (text_slot) text_slot.c();
			attr(div, "class", "item-text");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (text_slot) {
				text_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*text*/ 4) && t0_value !== (t0_value = plainText(/*text*/ ctx[2]) + "")) set_data(t0, t0_value);

			if (text_slot) {
				if (text_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(text_slot, text_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_text_slot_changes, get_text_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(text_slot, local);
			current = true;
		},
		o(local) {
			transition_out(text_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (text_slot) text_slot.d(detaching);
		}
	};
}

// (395:18) {#if !(swipeout || accordionItem)}
function create_if_block_8(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (398:18) {#if hasFooter}
function create_if_block_7(ctx) {
	let div;
	let t0_value = plainText(/*footer*/ ctx[6]) + "";
	let t0;
	let t1;
	let current;
	const footer_slot_template = /*#slots*/ ctx[68].footer;
	const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[82], get_footer_slot_context);

	return {
		c() {
			div = element("div");
			t0 = text_1(t0_value);
			t1 = space();
			if (footer_slot) footer_slot.c();
			attr(div, "class", "item-footer");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);

			if (footer_slot) {
				footer_slot.m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty[0] & /*footer*/ 64) && t0_value !== (t0_value = plainText(/*footer*/ ctx[6]) + "")) set_data(t0, t0_value);

			if (footer_slot) {
				if (footer_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(footer_slot, footer_slot_template, ctx, /*$$scope*/ ctx[82], dirty, get_footer_slot_changes, get_footer_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(footer_slot, local);
			current = true;
		},
		o(local) {
			transition_out(footer_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (footer_slot) footer_slot.d(detaching);
		}
	};
}

// (1051:4) {#if (isSortable && sortable !== false && !isSortableOpposite)}
function create_if_block_3(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "sortable-handler");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (1054:4) {#if (swipeout || accordionItem)}
function create_if_block_2(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[68].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[82], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty[2] & /*$$scope*/ 1048576) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[82], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

// (322:16) {plainText(title)}
function fallback_block(ctx) {
	let t_value = plainText(/*title*/ ctx[1]) + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*title*/ 2 && t_value !== (t_value = plainText(/*title*/ ctx[1]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block, create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*divider*/ ctx[12] || /*groupTitle*/ ctx[13]) return 0;
		if (/*isSimple*/ ctx[33]) return 1;
		return 2;
	}

	current_block_type_index = select_block_type(ctx, [-1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const omit_props_names = [
		"class","title","text","media","subtitle","header","footer","tooltip","tooltipTrigger","link","tabLink","tabLinkActive","selected","href","target","after","badge","badgeColor","mediaItem","mediaList","divider","groupTitle","swipeout","swipeoutOpened","sortable","sortableOpposite","accordionItem","accordionItemOpened","smartSelect","smartSelectParams","noChevron","chevronCenter","checkbox","radio","radioIcon","checked","indeterminate","name","value","readonly","required","disabled","virtualListIndex","routeProps","smartSelectInstance"
	];

	let $$restProps = compute_rest_props($$props, omit_props_names);
	let { $$slots: slots = {}, $$scope } = $$props;
	const emit = createEmitter(createEventDispatcher, $$props);
	let { class: className = undefined } = $$props;
	let { title = undefined } = $$props;
	let { text = undefined } = $$props;
	let { media = undefined } = $$props;
	let { subtitle = undefined } = $$props;
	let { header = undefined } = $$props;
	let { footer = undefined } = $$props;
	let { tooltip = undefined } = $$props;
	let { tooltipTrigger = undefined } = $$props;
	let { link = undefined } = $$props;
	let { tabLink = undefined } = $$props;
	let { tabLinkActive = false } = $$props;
	let { selected = false } = $$props;
	let { href = undefined } = $$props;
	let { target = undefined } = $$props;
	let { after = undefined } = $$props;
	let { badge = undefined } = $$props;
	let { badgeColor = undefined } = $$props;
	let { mediaItem = false } = $$props;
	let { mediaList = false } = $$props;
	let { divider = false } = $$props;
	let { groupTitle = false } = $$props;
	let { swipeout = false } = $$props;
	let { swipeoutOpened = false } = $$props;
	let { sortable = undefined } = $$props;
	let { sortableOpposite = undefined } = $$props;
	let { accordionItem = false } = $$props;
	let { accordionItemOpened = false } = $$props;
	let { smartSelect = false } = $$props;
	let { smartSelectParams = undefined } = $$props;
	let { noChevron = undefined } = $$props;
	let { chevronCenter = undefined } = $$props;
	let { checkbox = undefined } = $$props;
	let { radio = undefined } = $$props;
	let { radioIcon = undefined } = $$props;
	let { checked = undefined } = $$props;
	let { indeterminate = undefined } = $$props;
	let { name = undefined } = $$props;
	let { value = undefined } = $$props;
	let { readonly = undefined } = $$props;
	let { required = undefined } = $$props;
	let { disabled = undefined } = $$props;
	let { virtualListIndex = undefined } = $$props;
	let { routeProps = undefined } = $$props;
	let el;
	let linkEl;
	let innerEl;
	let inputEl;
	let f7SmartSelect;

	function smartSelectInstance() {
		return f7SmartSelect;
	}

	let ListContext = getReactiveContext("ListContext", value => {
		$$invalidate(84, ListContext = value || {});
	}) || {};

	/* eslint-enable no-undef */
	let initialWatchedOpened = false;

	function watchSwipeoutOpened(opened) {
		if (!initialWatchedOpened) {
			initialWatchedOpened = true;
			return;
		}

		if (!swipeout) return;

		if (opened) {
			f7.swipeout.open(el);
		} else {
			f7.swipeout.close(el);
		}
	}

	function onClick(event) {
		if (event.target.tagName.toLowerCase() !== "input") {
			emit("click", event);
		}
	}

	function onSwipeoutOverswipeEnter(eventEl) {
		if (eventEl !== el) return;
		emit("swipeoutOverswipeEnter");
	}

	function onSwipeoutOverswipeExit(eventEl) {
		if (eventEl !== el) return;
		emit("swipeoutOverswipeExit");
	}

	function onSwipeoutDeleted(eventEl) {
		if (eventEl !== el) return;
		emit("swipeoutDeleted");
	}

	function onSwipeoutDelete(eventEl) {
		if (eventEl !== el) return;
		emit("swipeoutDelete");
	}

	function onSwipeoutClose(eventEl) {
		if (eventEl !== el) return;
		emit("swipeoutClose");
	}

	function onSwipeoutClosed(eventEl) {
		if (eventEl !== el) return;
		emit("swipeoutClosed");
	}

	function onSwipeoutOpen(eventEl) {
		if (eventEl !== el) return;
		emit("swipeoutOpen");
	}

	function onSwipeoutOpened(eventEl) {
		if (eventEl !== el) return;
		emit("swipeoutOpened");
	}

	function onSwipeout(eventEl, progress) {
		if (eventEl !== el) return;
		emit("swipeout", progress);
	}

	function onAccBeforeClose(eventEl, prevent) {
		if (eventEl !== el) return;
		emit("accordionBeforeClose", [prevent]);
	}

	function onAccClose(eventEl) {
		if (eventEl !== el) return;
		emit("accordionClose");
	}

	function onAccClosed(eventEl) {
		if (eventEl !== el) return;
		emit("accordionClosed");
	}

	function onAccBeforeOpen(eventEl, prevent) {
		if (eventEl !== el) return;
		emit("accordionBeforeOpen", [prevent]);
	}

	function onAccOpen(eventEl) {
		if (eventEl !== el) return;
		emit("accordionOpen");
	}

	function onAccOpened(eventEl) {
		if (eventEl !== el) return;
		emit("accordionOpened");
	}

	function onChange(event) {
		emit("change", [event]);
		$$invalidate(0, checked = event.target.checked);
	}

	useSmartSelect(
		{ smartSelect, smartSelectParams },
		instance => {
			f7SmartSelect = instance;
		},
		() => linkEl
	);

	onMount(() => {
		if (indeterminate && inputEl) {
			$$invalidate(29, inputEl.indeterminate = true, inputEl);
		}

		f7ready(() => {
			if (swipeout) {
				f7.on("swipeoutOpen", onSwipeoutOpen);
				f7.on("swipeoutOpened", onSwipeoutOpened);
				f7.on("swipeoutClose", onSwipeoutClose);
				f7.on("swipeoutClosed", onSwipeoutClosed);
				f7.on("swipeoutDelete", onSwipeoutDelete);
				f7.on("swipeoutDeleted", onSwipeoutDeleted);
				f7.on("swipeoutOverswipeEnter", onSwipeoutOverswipeEnter);
				f7.on("swipeoutOverswipeExit", onSwipeoutOverswipeExit);
				f7.on("swipeout", onSwipeout);
			}

			if (accordionItem) {
				f7.on("accordionBeforeOpen", onAccBeforeOpen);
				f7.on("accordionOpen", onAccOpen);
				f7.on("accordionOpened", onAccOpened);
				f7.on("accordionBeforeClose", onAccBeforeClose);
				f7.on("accordionClose", onAccClose);
				f7.on("accordionClosed", onAccClosed);
			}

			if (swipeoutOpened) {
				f7.swipeout.open(el);
			}
		});
	});

	afterUpdate(() => {
		if (inputEl) {
			$$invalidate(29, inputEl.indeterminate = indeterminate, inputEl);
		}
	});

	onDestroy(() => {
		if (!f7) return;

		if (swipeout) {
			f7.off("swipeoutOpen", onSwipeoutOpen);
			f7.off("swipeoutOpened", onSwipeoutOpened);
			f7.off("swipeoutClose", onSwipeoutClose);
			f7.off("swipeoutClosed", onSwipeoutClosed);
			f7.off("swipeoutDelete", onSwipeoutDelete);
			f7.off("swipeoutDeleted", onSwipeoutDeleted);
			f7.off("swipeoutOverswipeEnter", onSwipeoutOverswipeEnter);
			f7.off("swipeoutOverswipeExit", onSwipeoutOverswipeExit);
			f7.off("swipeout", onSwipeout);
		}

		if (accordionItem) {
			f7.off("accordionBeforeOpen", onAccBeforeOpen);
			f7.off("accordionOpen", onAccOpen);
			f7.off("accordionOpened", onAccOpened);
			f7.off("accordionBeforeClose", onAccBeforeClose);
			f7.off("accordionClose", onAccClose);
			f7.off("accordionClosed", onAccClosed);
		}
	});

	function li_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			el = $$value;
			$$invalidate(26, el);
		});
	}

	function li_binding_1($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			el = $$value;
			$$invalidate(26, el);
		});
	}

	function div0_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			innerEl = $$value;
			$$invalidate(28, innerEl);
		});
	}

	function a_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			linkEl = $$value;
			$$invalidate(27, linkEl);
		});
	}

	function input_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			inputEl = $$value;
			$$invalidate(29, inputEl);
		});
	}

	function div_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			innerEl = $$value;
			$$invalidate(28, innerEl);
		});
	}

	function div0_binding_1($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			innerEl = $$value;
			$$invalidate(28, innerEl);
		});
	}

	function div0_binding_2($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			innerEl = $$value;
			$$invalidate(28, innerEl);
		});
	}

	function a_binding_1($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			linkEl = $$value;
			$$invalidate(27, linkEl);
		});
	}

	function input_binding_1($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			inputEl = $$value;
			$$invalidate(29, inputEl);
		});
	}

	function div_binding_1($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			innerEl = $$value;
			$$invalidate(28, innerEl);
		});
	}

	function div0_binding_3($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			innerEl = $$value;
			$$invalidate(28, innerEl);
		});
	}

	function li_binding_2($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			el = $$value;
			$$invalidate(26, el);
		});
	}

	$$self.$$set = $$new_props => {
		$$invalidate(103, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
		$$invalidate(48, $$restProps = compute_rest_props($$props, omit_props_names));
		if ("class" in $$new_props) $$invalidate(49, className = $$new_props.class);
		if ("title" in $$new_props) $$invalidate(1, title = $$new_props.title);
		if ("text" in $$new_props) $$invalidate(2, text = $$new_props.text);
		if ("media" in $$new_props) $$invalidate(3, media = $$new_props.media);
		if ("subtitle" in $$new_props) $$invalidate(4, subtitle = $$new_props.subtitle);
		if ("header" in $$new_props) $$invalidate(5, header = $$new_props.header);
		if ("footer" in $$new_props) $$invalidate(6, footer = $$new_props.footer);
		if ("tooltip" in $$new_props) $$invalidate(7, tooltip = $$new_props.tooltip);
		if ("tooltipTrigger" in $$new_props) $$invalidate(8, tooltipTrigger = $$new_props.tooltipTrigger);
		if ("link" in $$new_props) $$invalidate(50, link = $$new_props.link);
		if ("tabLink" in $$new_props) $$invalidate(51, tabLink = $$new_props.tabLink);
		if ("tabLinkActive" in $$new_props) $$invalidate(52, tabLinkActive = $$new_props.tabLinkActive);
		if ("selected" in $$new_props) $$invalidate(53, selected = $$new_props.selected);
		if ("href" in $$new_props) $$invalidate(54, href = $$new_props.href);
		if ("target" in $$new_props) $$invalidate(55, target = $$new_props.target);
		if ("after" in $$new_props) $$invalidate(9, after = $$new_props.after);
		if ("badge" in $$new_props) $$invalidate(10, badge = $$new_props.badge);
		if ("badgeColor" in $$new_props) $$invalidate(11, badgeColor = $$new_props.badgeColor);
		if ("mediaItem" in $$new_props) $$invalidate(56, mediaItem = $$new_props.mediaItem);
		if ("mediaList" in $$new_props) $$invalidate(57, mediaList = $$new_props.mediaList);
		if ("divider" in $$new_props) $$invalidate(12, divider = $$new_props.divider);
		if ("groupTitle" in $$new_props) $$invalidate(13, groupTitle = $$new_props.groupTitle);
		if ("swipeout" in $$new_props) $$invalidate(14, swipeout = $$new_props.swipeout);
		if ("swipeoutOpened" in $$new_props) $$invalidate(58, swipeoutOpened = $$new_props.swipeoutOpened);
		if ("sortable" in $$new_props) $$invalidate(15, sortable = $$new_props.sortable);
		if ("sortableOpposite" in $$new_props) $$invalidate(59, sortableOpposite = $$new_props.sortableOpposite);
		if ("accordionItem" in $$new_props) $$invalidate(16, accordionItem = $$new_props.accordionItem);
		if ("accordionItemOpened" in $$new_props) $$invalidate(60, accordionItemOpened = $$new_props.accordionItemOpened);
		if ("smartSelect" in $$new_props) $$invalidate(61, smartSelect = $$new_props.smartSelect);
		if ("smartSelectParams" in $$new_props) $$invalidate(62, smartSelectParams = $$new_props.smartSelectParams);
		if ("noChevron" in $$new_props) $$invalidate(63, noChevron = $$new_props.noChevron);
		if ("chevronCenter" in $$new_props) $$invalidate(64, chevronCenter = $$new_props.chevronCenter);
		if ("checkbox" in $$new_props) $$invalidate(17, checkbox = $$new_props.checkbox);
		if ("radio" in $$new_props) $$invalidate(18, radio = $$new_props.radio);
		if ("radioIcon" in $$new_props) $$invalidate(65, radioIcon = $$new_props.radioIcon);
		if ("checked" in $$new_props) $$invalidate(0, checked = $$new_props.checked);
		if ("indeterminate" in $$new_props) $$invalidate(66, indeterminate = $$new_props.indeterminate);
		if ("name" in $$new_props) $$invalidate(19, name = $$new_props.name);
		if ("value" in $$new_props) $$invalidate(20, value = $$new_props.value);
		if ("readonly" in $$new_props) $$invalidate(21, readonly = $$new_props.readonly);
		if ("required" in $$new_props) $$invalidate(22, required = $$new_props.required);
		if ("disabled" in $$new_props) $$invalidate(23, disabled = $$new_props.disabled);
		if ("virtualListIndex" in $$new_props) $$invalidate(24, virtualListIndex = $$new_props.virtualListIndex);
		if ("routeProps" in $$new_props) $$invalidate(25, routeProps = $$new_props.routeProps);
		if ("$$scope" in $$new_props) $$invalidate(82, $$scope = $$new_props.$$scope);
	};

	let isMedia;
	let isSortable;
	let isSortableOpposite;
	let isSimple;
	let liClasses;
	let contentClasses;
	let linkClasses;
	let linkAttrs;
	let isLink;
	let hasMedia;
	let hasTitle;
	let hasHeader;
	let hasFooter;
	let hasSubtitle;
	let hasText;
	let hasAfter;

	$$self.$$.update = () => {
		if ($$self.$$.dirty[1] & /*mediaList, mediaItem*/ 100663296 | $$self.$$.dirty[2] & /*ListContext*/ 4194304) {
			$: $$invalidate(30, isMedia = mediaList || mediaItem || ListContext.listIsMedia);
		}

		if ($$self.$$.dirty[0] & /*sortable*/ 32768 | $$self.$$.dirty[2] & /*ListContext*/ 4194304) {
			$: $$invalidate(31, isSortable = sortable || ListContext.listIsSortable);
		}

		if ($$self.$$.dirty[1] & /*sortableOpposite*/ 268435456 | $$self.$$.dirty[2] & /*ListContext*/ 4194304) {
			$: $$invalidate(32, isSortableOpposite = sortableOpposite || ListContext.listIsSortableOpposite);
		}

		if ($$self.$$.dirty[2] & /*ListContext*/ 4194304) {
			$: $$invalidate(33, isSimple = ListContext.listIsSimple);
		}

		$: $$invalidate(34, liClasses = classNames(
			className,
			{
				"item-divider": divider,
				"list-group-title": groupTitle,
				"media-item": isMedia,
				swipeout,
				"accordion-item": accordionItem,
				"accordion-item-opened": accordionItemOpened,
				disabled: disabled && !(radio || checkbox),
				"no-chevron": noChevron,
				"chevron-center": chevronCenter,
				"disallow-sorting": sortable === false
			},
			colorClasses($$props)
		));

		$: $$invalidate(35, contentClasses = classNames(
			className,
			"item-content",
			{
				"item-checkbox": checkbox,
				"item-radio": radio,
				"item-radio-icon-start": radio && radioIcon === "start",
				"item-radio-icon-end": radio && radioIcon === "end"
			},
			colorClasses($$props)
		));

		$: $$invalidate(36, linkClasses = classNames(
			{
				"item-link": true,
				"smart-select": smartSelect,
				"tab-link": tabLink || tabLink === "",
				"tab-link-active": tabLinkActive,
				"item-selected": selected
			},
			routerClasses($$props),
			actionsClasses($$props)
		));

		$: $$invalidate(37, linkAttrs = {
			href: link === true ? "" : link || href,
			target,
			"data-tab": isStringProp(tabLink) && tabLink || undefined,
			...routerAttrs($$props),
			...actionsAttrs($$props)
		});

		if ($$self.$$.dirty[0] & /*accordionItem*/ 65536 | $$self.$$.dirty[1] & /*link, href, smartSelect*/ 1082654720) {
			$: $$invalidate(38, isLink = link || href || smartSelect || accordionItem);
		}

		if ($$self.$$.dirty[0] & /*media*/ 8) {
			/* eslint-disable no-undef */
			$: $$invalidate(39, hasMedia = typeof media !== "undefined" || hasSlots(arguments, "media"));
		}

		if ($$self.$$.dirty[0] & /*title*/ 2) {
			$: $$invalidate(40, hasTitle = typeof title !== "undefined" || hasSlots(arguments, "title"));
		}

		if ($$self.$$.dirty[0] & /*header*/ 32) {
			$: $$invalidate(41, hasHeader = typeof header !== "undefined" || hasSlots(arguments, "header"));
		}

		if ($$self.$$.dirty[0] & /*footer*/ 64) {
			$: $$invalidate(42, hasFooter = typeof footer !== "undefined" || hasSlots(arguments, "footer"));
		}

		if ($$self.$$.dirty[0] & /*subtitle*/ 16) {
			$: $$invalidate(43, hasSubtitle = typeof subtitle !== "undefined" || hasSlots(arguments, "subtitle"));
		}

		if ($$self.$$.dirty[0] & /*text*/ 4) {
			$: $$invalidate(44, hasText = typeof text !== "undefined" || hasSlots(arguments, "text"));
		}

		if ($$self.$$.dirty[0] & /*after, badge*/ 1536) {
			$: $$invalidate(45, hasAfter = typeof after !== "undefined" || typeof badge !== "undefined" || hasSlots(arguments, "after"));
		}

		if ($$self.$$.dirty[1] & /*swipeoutOpened*/ 134217728) {
			$: watchSwipeoutOpened(swipeoutOpened);
		}
	};

	$$props = exclude_internal_props($$props);

	return [
		checked,
		title,
		text,
		media,
		subtitle,
		header,
		footer,
		tooltip,
		tooltipTrigger,
		after,
		badge,
		badgeColor,
		divider,
		groupTitle,
		swipeout,
		sortable,
		accordionItem,
		checkbox,
		radio,
		name,
		value,
		readonly,
		required,
		disabled,
		virtualListIndex,
		routeProps,
		el,
		linkEl,
		innerEl,
		inputEl,
		isMedia,
		isSortable,
		isSortableOpposite,
		isSimple,
		liClasses,
		contentClasses,
		linkClasses,
		linkAttrs,
		isLink,
		hasMedia,
		hasTitle,
		hasHeader,
		hasFooter,
		hasSubtitle,
		hasText,
		hasAfter,
		onClick,
		onChange,
		$$restProps,
		className,
		link,
		tabLink,
		tabLinkActive,
		selected,
		href,
		target,
		mediaItem,
		mediaList,
		swipeoutOpened,
		sortableOpposite,
		accordionItemOpened,
		smartSelect,
		smartSelectParams,
		noChevron,
		chevronCenter,
		radioIcon,
		indeterminate,
		smartSelectInstance,
		slots,
		li_binding,
		li_binding_1,
		div0_binding,
		a_binding,
		input_binding,
		div_binding,
		div0_binding_1,
		div0_binding_2,
		a_binding_1,
		input_binding_1,
		div_binding_1,
		div0_binding_3,
		li_binding_2,
		$$scope
	];
}

class List_item extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				class: 49,
				title: 1,
				text: 2,
				media: 3,
				subtitle: 4,
				header: 5,
				footer: 6,
				tooltip: 7,
				tooltipTrigger: 8,
				link: 50,
				tabLink: 51,
				tabLinkActive: 52,
				selected: 53,
				href: 54,
				target: 55,
				after: 9,
				badge: 10,
				badgeColor: 11,
				mediaItem: 56,
				mediaList: 57,
				divider: 12,
				groupTitle: 13,
				swipeout: 14,
				swipeoutOpened: 58,
				sortable: 15,
				sortableOpposite: 59,
				accordionItem: 16,
				accordionItemOpened: 60,
				smartSelect: 61,
				smartSelectParams: 62,
				noChevron: 63,
				chevronCenter: 64,
				checkbox: 17,
				radio: 18,
				radioIcon: 65,
				checked: 0,
				indeterminate: 66,
				name: 19,
				value: 20,
				readonly: 21,
				required: 22,
				disabled: 23,
				virtualListIndex: 24,
				routeProps: 25,
				smartSelectInstance: 67
			},
			[-1, -1, -1, -1]
		);
	}

	get smartSelectInstance() {
		return this.$$.ctx[67];
	}
}

export default List_item;